import React, { useState, useEffect, useCallback, useContext, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSeasonYear, useSeasonYearContext } from '../context/SeasonYearContext';
import { useAuth } from '../context/AuthContext';
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Select,
  MenuItem,
  Menu,
  FormControl,
  InputLabel,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  FormControlLabel,
  Switch,
  Paper,
  Card,
  CardContent,
  InputAdornment,
  Stack,
  Tooltip,
  Chip,
  Alert,
  Snackbar,
  RadioGroup,
  FormControlLabel as MuiFormControlLabel,
  Radio,
  FormLabel
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { API_URL } from '../config';
import { fetchApi, authedFetch } from '../utils/apiUtils';
import FlagIcon from '@mui/icons-material/Flag';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SpeedIcon from '@mui/icons-material/Speed';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorAlert from './ErrorAlert';
import debounce from 'lodash.debounce';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

dayjs.extend(utc);

const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

function RaceEntry() {
  const { is_read_only } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const autoOpenEventId = useRef(searchParams.get('event') ? parseInt(searchParams.get('event')) : null);
  const configuredSeasonYear = useSeasonYear();
  const { setSeasonYear: setGlobalSeasonYear } = useSeasonYearContext();
  const [seasonAnchorEl, setSeasonAnchorEl] = useState(null);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [events, setEvents] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditEventDialog, setOpenEditEventDialog] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const [openChangeTrackDialog, setOpenChangeTrackDialog] = useState(false);
  const [changeTrackEvent, setChangeTrackEvent] = useState(null);
  const [changeTrackSelected, setChangeTrackSelected] = useState(null);
  const [changeTrackSaving, setChangeTrackSaving] = useState(false);
  const [openRacesDialog, setOpenRacesDialog] = useState(false);
  const [eventDate, setEventDate] = useState(dayjs());
  const [eventName, setEventName] = useState('');
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [notes, setNotes] = useState('');
  const [isCancelled, setIsCancelled] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [tracks, setTracks] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [regions] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventRaces, setEventRaces] = useState([]);
  const [openNewRaceDialog, setOpenNewRaceDialog] = useState(false);
  const [newRace, setNewRace] = useState({
    race_name: '',
    race_type: 'FEATURE',
    car_count: '',
    notes: '',
    race_order: 1
  });
  const [editingRace, setEditingRace] = useState(null);
  const [openEditRaceDialog, setOpenEditRaceDialog] = useState(false);
  const [openResultsDialog, setOpenResultsDialog] = useState(false);
  const [selectedRace, setSelectedRace] = useState(null);
  const [raceResults, setRaceResults] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [carCount, setCarCount] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [availableFilterRegions, setAvailableFilterRegions] = useState([]);
  const [error, setError] = useState(null);
  const [pointsType, setPointsType] = useState('national_and_regional');
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [alert, setAlert] = useState({ show: false, message: '', severity: 'success' });
  const [allRegions, setAllRegions] = useState([]);
  const [availableRegions, setAvailableRegions] = useState([]);
  const [openNewDriverDialog, setOpenNewDriverDialog] = useState(false);
  const [newDriver, setNewDriver] = useState({
    first_name: '',
    last_name: '',
    hometown: '',
    state: '',
    country: 'US',
    car_number: '',
    is_current_member: false
  });
  const [driverSearchInputs, setDriverSearchInputs] = useState({});
  const [driverSearchResultsMap, setDriverSearchResultsMap] = useState({});
  const [driverSearchLoadingMap, setDriverSearchLoadingMap] = useState({});
  const [stats, setStats] = useState({
    totalEvents: 0,
    totalCars: 0,
    uniqueTracks: 0,
    averageCarsPerEvent: 0
  });
  const [filterDivision, setFilterDivision] = useState('');
  const [filterRegion, setFilterRegion] = useState('');
  const [filterTrack, setFilterTrack] = useState('');
  const [allTracks, setAllTracks] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [eventsWithRaces, setEventsWithRaces] = useState({});
  const [featureWinners, setFeatureWinners] = useState({});
  const [savingStatus, setSavingStatus] = useState({ status: '', message: '' });
  const [openSavingDialog, setOpenSavingDialog] = useState(false);
  const [series, setSeries] = useState([]);
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingEditData, setIsLoadingEditData] = useState(false);
  
  // Separate state for edit form to avoid conflicts
  const [editEventName, setEditEventName] = useState('');
  const [editEventDate, setEditEventDate] = useState(dayjs());
  const [editSelectedTrack, setEditSelectedTrack] = useState(null);
  const [editSelectedDivision, setEditSelectedDivision] = useState(null);
  const [editSelectedRegion, setEditSelectedRegion] = useState(null);
  const [editSeasonYear, setEditSeasonYear] = useState(configuredSeasonYear);
  const [editCarCount, setEditCarCount] = useState('');
  const [editNotes, setEditNotes] = useState('');
  const [editIsCancelled, setEditIsCancelled] = useState(false);
  const [editCancelReason, setEditCancelReason] = useState('');
  const [editPointsType, setEditPointsType] = useState('national_and_regional');
  const [editSelectedSeries, setEditSelectedSeries] = useState(null);
  const [editAvailableRegions, setEditAvailableRegions] = useState([]);
  const [addEventErrors, setAddEventErrors] = useState({});
  
  const driverCache = React.useRef({});
  
  const [mrpResultsEventId, setMrpResultsEventId] = useState('');
  const [mrpResultsLoading, setMrpResultsLoading] = useState(false);
  const [mrpPreviewLoading, setMrpPreviewLoading] = useState(false);
  const [mrpPreviewData, setMrpPreviewData] = useState(null);
  const [selectedMrpDivision, setSelectedMrpDivision] = useState('');
  const [showDivisionMismatchDialog, setShowDivisionMismatchDialog] = useState(false);
  const [divisionMismatchData, setDivisionMismatchData] = useState(null);

  // Define race types with their display order
  const raceTypes = [
    { value: 'FEATURE', label: 'Feature', order: 1 },
    { value: 'LAST_CHANCE', label: 'Last Chance', order: 2 },
    { value: 'C_MAIN', label: 'C-Main', order: 3 },
    { value: 'D_MAIN', label: 'D-Main', order: 4 },
    { value: 'E_MAIN', label: 'E-Main', order: 5 }
  ];

  // Add status options
  const statusOptions = [
    { value: 'FINISHED', label: 'Finished' },
    { value: 'DNF', label: 'Did Not Finish' },
    { value: 'DNS', label: 'Did Not Start' },
    { value: 'DQ', label: 'Disqualified' }
  ];

  const cancelReasonOptions = [
    { value: 'RAINED_OUT', label: 'Rained Out' },
    { value: 'CANCELLED', label: 'Cancelled' }
  ];

  const handleError = (error, customMessage = null) => {
    setError(customMessage || {
      message: error.message,
      details: error.response?.data?.error?.details
    });
  };

  const handlePreviewMyRacePassDivisions = async () => {
    if (!mrpResultsEventId.trim()) {
      setAlert({
        show: true,
        message: 'Please enter a MyRacePass Event ID or URL',
        severity: 'error',
      });
      return;
    }

    // Extract event ID from URL if a full URL is provided
    let eventId = mrpResultsEventId.trim();
    const urlMatch = eventId.match(/myracepass\.com\/events\/(\d+)/);
    if (urlMatch) {
      eventId = urlMatch[1];
    }

    setMrpPreviewLoading(true);
    try {
      const response = await authedFetch(`${API_URL}/myraceplass/preview-divisions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventId: eventId,
          localDivisionName: selectedEvent?.division_name || null,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to preview MyRacePass divisions');
      }

      setMrpPreviewData(data);
      const defaultDivision =
        data.suggested_mrp_division_name ||
        (data.divisions.length === 1 ? data.divisions[0].mrp_division_name : '');
      setSelectedMrpDivision(defaultDivision);

      setAlert({
        show: true,
        message: `Found ${data.divisions.length} division${data.divisions.length === 1 ? '' : 's'} in MyRacePass event`,
        severity: 'success',
      });

    } catch (error) {
      console.error('MyRacePass preview error:', error);
      setAlert({
        show: true,
        message: `Error previewing MyRacePass divisions: ${error.message}`,
        severity: 'error',
      });
    } finally {
      setMrpPreviewLoading(false);
    }
  };

  const handleImportMyRacePassResults = async () => {
    if (is_read_only) {
      setAlert({
        show: true,
        message: 'Read-only users cannot import race results',
        severity: 'error',
      });
      return;
    }

    if (!mrpResultsEventId.trim()) {
      setAlert({
        show: true,
        message: 'Please enter a MyRacePass Event ID or URL',
        severity: 'error',
      });
      return;
    }

    // Extract event ID from URL if a full URL is provided
    let eventId = mrpResultsEventId.trim();
    const urlMatch = eventId.match(/myracepass\.com\/events\/(\d+)/);
    if (urlMatch) {
      eventId = urlMatch[1];
    }

    if (!selectedRace || !selectedEvent) {
      setAlert({
        show: true,
        message: 'Error: No race selected for import',
        severity: 'error',
      });
      return;
    }

    if (!selectedMrpDivision) {
      setAlert({
        show: true,
        message: 'Pick a MyRacePass division before importing.',
        severity: 'error',
      });
      return;
    }

    setMrpResultsLoading(true);
    try {
      const response = await authedFetch(`${API_URL}/myraceplass/import-results`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventId: eventId,
          raceId: selectedRace.race_id.toString(),
          divisionName: selectedMrpDivision,
          raceName: selectedRace.race_name,
          strictDivisionMatch: true
        }),
      });

      // Read response as text first, then try to parse as JSON
      const responseText = await response.text();
      
      if (!response.ok) {
        let errorMessage = 'Failed to import MyRacePass results';
        let errorData = null;
        try {
          errorData = JSON.parse(responseText);
          errorMessage = errorData.error || errorMessage;

          if (response.status === 401) {
            errorMessage = 'Your session has expired. Please log in again to import MyRacePass results.';
          } else if (response.status === 403) {
            errorMessage = 'You do not have permission to import MyRacePass results (read-only access).';
          }
          
          // Handle division mismatch specifically
          if (response.status === 404 && errorData.availableDivisions) {
            setDivisionMismatchData({
              localDivision: selectedEvent.division_name,
              availableDivisions: errorData.availableDivisions,
              suggestion: errorData.suggestion
            });
            setShowDivisionMismatchDialog(true);
            return; // Don't throw error, show dialog instead
          }
        } catch (parseError) {
          // If response is not JSON, use the text content
          if (response.status === 401) {
            errorMessage = 'Your session has expired. Please log in again to import MyRacePass results.';
          } else if (response.status === 403) {
            errorMessage = 'You do not have permission to import MyRacePass results (read-only access).';
          } else {
            errorMessage = responseText || `HTTP ${response.status}: ${response.statusText}`;
          }
        }
        throw new Error(errorMessage);
      }

      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        throw new Error(`Invalid response format. Expected JSON but received: ${responseText.substring(0, 200)}...`);
      }
      
      // Process results and assign sequential positions to DNS entries
      const processedResults = data.results.map((result, index) => ({
        temp_id: `mrp-import-${index}`,
        finish_position: result.finish_position,
        driver_id: result.driver_id,
        driver: result.driver_id ? result.database_driver : null,
        car_number: result.car_number,
        points_earned: null,
        status: result.status || 'FINISHED',
        notes: result.driver_matched ? 
          `✅ ${result.driver_match_type}: ${result.database_driver.first_name} ${result.database_driver.last_name}` :
          `❌ ${result.error || 'Match failed'}: ${result.driver_name} - ${result.hometown}`,
        calculated_points: null,
        manual_points_input: '',
        is_manual_points: false,
        saveError: null,
        // Store MRP data for reference
        mrp_driver_name: result.driver_name,
        mrp_hometown: result.hometown,
        mrp_driver_id: result.mrp_driver_id,
        driver_match_type: result.driver_match_type,
        driver_matched: result.driver_matched
      }));

      // Find the highest position number from ALL drivers with positions (including DNF)
      const allPositions = processedResults
        .filter(r => r.finish_position !== null)
        .map(r => parseInt(r.finish_position))
        .filter(p => !isNaN(p));
      
      const highestPosition = allPositions.length > 0 ? Math.max(...allPositions) : 0;
      
      // Assign sequential positions to DNS entries
      let nextDNSPosition = highestPosition + 1;
      const importedResults = processedResults.map(result => {
        if (result.finish_position === null && result.status === 'DNS') {
          return {
            ...result,
            finish_position: nextDNSPosition++
          };
        }
        return {
          ...result,
          finish_position: result.finish_position?.toString() || ''
        };
      });

      // Update driver cache and search results map for imported drivers
      const newDriverSearchResultsMap = {};
      const newDriverSearchInputs = {};
      
      importedResults.forEach((result, index) => {
        if (result.driver_id && result.driver) {
          // Add to driver cache
          driverCache.current[result.driver_id] = result.driver;
          
          // Set up search results for this row to show the matched driver
          newDriverSearchResultsMap[index] = [result.driver];
          
          // Set the input to show the matched driver name
          newDriverSearchInputs[index] = `${result.driver.car_number} - ${result.driver.first_name} ${result.driver.last_name}`;
        }
      });
      
      // Update search results map and inputs
      setDriverSearchResultsMap(prev => ({ ...prev, ...newDriverSearchResultsMap }));
      setDriverSearchInputs(prev => ({ ...prev, ...newDriverSearchInputs }));

      // Pad with empty results for missing positions
      const targetCarCount = selectedRace.car_count || 24;
      
      // Create a set of existing positions from imported results
      const importedPositions = new Set(
        importedResults
          .map(r => parseInt(r.finish_position))
          .filter(p => !isNaN(p))
      );
      
      // Create empty results for missing positions (1 through targetCarCount)
      const emptyResults = [];
      for (let position = 1; position <= targetCarCount; position++) {
        if (!importedPositions.has(position)) {
          emptyResults.push({
            temp_id: `empty-position-${position}`,
            finish_position: position.toString(),
            driver_id: null,
            driver: null,
            car_number: '',
            points_earned: null,
            status: 'FINISHED',
            notes: '',
            calculated_points: null,
            manual_points_input: '',
            is_manual_points: false,
            saveError: null
          });
        }
      }

      // Merge and sort results by position
      const allResults = [...importedResults, ...emptyResults].sort((a, b) => {
        const posA = parseInt(a.finish_position) || 999;
        const posB = parseInt(b.finish_position) || 999;
        return posA - posB;
      });
      
      setRaceResults(allResults);
      
      // Show detailed import summary
      const stats = data.matchingStats;
      const summary = data.summary;
      const divisionMatchInfo = data.divisionMatchType ? ` (Division matched: ${data.divisionMatchType})` : '';
      
      setAlert({
        show: true,
        message: `✅ Import completed! ${summary.successfulMatches}/${summary.totalDrivers} drivers matched${divisionMatchInfo}. ` +
                `Exact: ${stats.exact}, Hometown: ${stats.hometown}, State: ${stats.state}, ` +
                `Name: ${stats.nameUnique}, Fuzzy: ${stats.fuzzy}, New: ${stats.created}`,
        severity: 'success',
      });

    } catch (error) {
      console.error('MyRacePass import error:', error);
      setAlert({
        show: true,
        message: `Error importing MyRacePass results: ${error.message}`,
        severity: 'error',
      });
    } finally {
      setMrpResultsLoading(false);
    }
  };





  const fetchTracksByAssignment = useCallback(async () => {
    try {
      const queryParams = new URLSearchParams({
        division_id: selectedDivision.division_id,
        season_year: configuredSeasonYear,
      });

      // For national_only, we want ALL tracks for this division (don't filter by region)
      // For regional events, filter by the selected region
      if ((pointsType === 'national_and_regional' || pointsType === 'regional_only') && selectedRegion?.region_id) {
        queryParams.append('region_id', selectedRegion.region_id);
      }

      const response = await authedFetch(
        `${API_URL}/tracks/by-assignment?${queryParams.toString()}`
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || 'Failed to fetch tracks');
      }

      setTracks(data);
      if (!isLoadingEditData) {
        setSelectedTrack(null);
      }
    } catch (error) {
      handleError(error, {
        message: 'Unable to load tracks',
        details: 'Please check your division and region selection'
      });
    }
  }, [selectedDivision, selectedRegion, configuredSeasonYear, pointsType, isLoadingEditData]);

  const fetchAllTracks = useCallback(async () => {
    try {
      const data = await fetchApi(`${API_URL}/tracks`);
      setTracks(data);
      if (!isLoadingEditData) {
        setSelectedTrack(null);
      }
    } catch (error) {
      handleError(error, {
        message: 'Unable to load all tracks',
        details: 'Please try again later.'
      });
    }
  }, [isLoadingEditData]);

  const fetchEvents = useCallback(async () => {
    setLoading(true);
    try {
      const response = await authedFetch(`${API_URL}/races`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const eventsData = Array.isArray(data) ? data : [];
      setEvents(eventsData);
      setFilteredEvents(eventsData);
      calculateStats(eventsData);
      
      // Check which events have races and fetch winners in parallel
      await Promise.all([
        checkEventsWithRaces(eventsData),
        fetchFeatureWinners(eventsData)
      ]);
    } catch (error) {
      console.error('Error fetching events:', error);
      setAlert({
        show: true,
        message: 'Error loading events',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const checkEventsWithRaces = useCallback(async (eventsData) => {
    try {
      // Extract event IDs
      const eventIds = eventsData.map(event => event.event_id);
      
      // Use batch endpoint to check all events at once
      const raceChecks = await fetchApi(`${API_URL}/races/batch-check-races`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ eventIds })
      });
      
      setEventsWithRaces(raceChecks);
    } catch (error) {
      console.error('Error checking events with races:', error);
      // Fallback: mark all as unknown
      const fallbackChecks = {};
      eventsData.forEach(event => {
        fallbackChecks[event.event_id] = null; // null indicates unknown status
      });
      setEventsWithRaces(fallbackChecks);
    }
  }, []);

  const fetchFeatureWinners = useCallback(async (eventsData) => {
    try {
      // Extract event IDs
      const eventIds = eventsData.map(event => event.event_id);
      
      // Use batch endpoint to fetch feature winners
      const winners = await fetchApi(`${API_URL}/races/batch-feature-winners`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ eventIds })
      });
      
      setFeatureWinners(winners);
    } catch (error) {
      console.error('Error fetching feature winners:', error);
      // Fallback: mark all as unknown
      const fallbackWinners = {};
      eventsData.forEach(event => {
        fallbackWinners[event.event_id] = null;
      });
      setFeatureWinners(fallbackWinners);
    }
  }, []);

  const fetchDrivers = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchApi(`${API_URL}/drivers`);
      setDrivers(data);
    } catch (error) {
      console.error('Error fetching drivers:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const divisionRegionsRequestIdRef = useRef(0);
  const editDivisionRegionsRequestIdRef = useRef(0);
  const filterDivisionRegionsRequestIdRef = useRef(0);
  const editEventLoadRequestIdRef = useRef(0);

  const fetchDivisionRegions = useCallback(async (divisionId) => {
    const requestId = ++divisionRegionsRequestIdRef.current;
    try {
      const response = await authedFetch(
        `${API_URL}/division-regions/${divisionId}?season_year=${configuredSeasonYear}`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch division regions');
      }
      const data = await response.json();
      if (requestId !== divisionRegionsRequestIdRef.current) return;

      const filteredRegions = allRegions.filter(region =>
        data.some(dr => dr.region_id === region.region_id)
      );

      setAvailableRegions(filteredRegions);
    } catch (error) {
      if (requestId !== divisionRegionsRequestIdRef.current) return;
      console.error('Error fetching division regions:', error);
      setAlert({
        show: true,
        message: 'Error loading regions for division',
        severity: 'error',
      });
      setAvailableRegions([]);
    }
  }, [allRegions, configuredSeasonYear]);

  const fetchEditDivisionRegions = useCallback(async (divisionId, seasonYearOverride) => {
    const requestId = ++editDivisionRegionsRequestIdRef.current;
    try {
      const seasonYear = seasonYearOverride ?? editSeasonYear ?? configuredSeasonYear;
      const response = await authedFetch(
        `${API_URL}/division-regions/${divisionId}?season_year=${seasonYear}`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch division regions');
      }
      const data = await response.json();
      if (requestId !== editDivisionRegionsRequestIdRef.current) return;

      const filteredRegions = allRegions.filter(region =>
        data.some(dr => dr.region_id === region.region_id)
      );

      setEditAvailableRegions(filteredRegions);
    } catch (error) {
      if (requestId !== editDivisionRegionsRequestIdRef.current) return;
      console.error('Error fetching division regions for edit:', error);
      setAlert({
        show: true,
        message: 'Error loading regions for division',
        severity: 'error',
      });
      setEditAvailableRegions([]);
    }
  }, [allRegions, editSeasonYear, configuredSeasonYear]);



  const fetchRegions = useCallback(async () => {
    try {
      const response = await authedFetch(`${API_URL}/regions`);
      if (!response.ok) {
        throw new Error('Failed to fetch regions');
      }
      const data = await response.json();
      const regionsData = Array.isArray(data) ? data : [];
      setAllRegions(regionsData);
      setAvailableRegions([]); // Start with empty available regions until division is selected
    } catch (error) {
      console.error('Error fetching regions:', error);
      setAlert({
        show: true,
        message: 'Error loading regions',
        severity: 'error',
      });
      setAllRegions([]);
      setAvailableRegions([]);
    }
  }, []);

  const fetchAllTracksForFilter = useCallback(async () => {
    try {
      const response = await authedFetch(`${API_URL}/tracks`);
      if (!response.ok) {
        throw new Error('Failed to fetch tracks');
      }
      const data = await response.json();
      setAllTracks(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching tracks for filter:', error);
      setAlert({
        show: true,
        message: 'Error loading tracks',
        severity: 'error',
      });
      setAllTracks([]);
    }
  }, []);

  const fetchDivisions = useCallback(async () => {
    try {
      const response = await authedFetch(`${API_URL}/divisions`);
      if (!response.ok) {
        throw new Error('Failed to fetch divisions');
      }
      const data = await response.json();
      setDivisions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching divisions:', error);
      setAlert({
        show: true,
        message: 'Error loading divisions',
        severity: 'error',
      });
      setDivisions([]);
    }
  }, []);

  useEffect(() => {
    fetchEvents();
    fetchDrivers();
    fetchDivisions();
    fetchRegions();
    fetchAllTracksForFilter();
  }, [fetchEvents, fetchDrivers, fetchDivisions, fetchRegions, fetchAllTracksForFilter]);

  // Auto-open races dialog if navigated with ?event=<id>
  useEffect(() => {
    if (autoOpenEventId.current && events.length > 0) {
      const event = events.find(e => e.event_id === autoOpenEventId.current);
      if (event) {
        autoOpenEventId.current = null; // Only auto-open once
        searchParams.delete('event');
        setSearchParams(searchParams, { replace: true });
        handleManageRaces(event);
      } else {
        // The deep-linked event no longer exists (stale link / deleted event).
        // Clear the param so this doesn't retry, and explain why nothing opened.
        autoOpenEventId.current = null;
        searchParams.delete('event');
        setSearchParams(searchParams, { replace: true });
        setAlert({
          show: true,
          message: 'That event could not be found or is no longer available.',
          severity: 'warning',
        });
      }
    }
  }, [events]);

  useEffect(() => {
    if (isLoadingEditData) {
      console.log('useEffect prevented: tracks useEffect blocked by isLoadingEditData');
      return; // Don't interfere when loading edit data
    }
    
    if (selectedDivision) {
      fetchTracksByAssignment();
    } else {
      setTracks([]);
      setSelectedTrack(null);
    }
  }, [selectedDivision, selectedRegion, fetchTracksByAssignment, isLoadingEditData]);

  useEffect(() => {
    if (isLoadingEditData) {
      console.log('useEffect prevented: regions useEffect blocked by isLoadingEditData');
      return; // Don't interfere when loading edit data
    }
    
    if (selectedDivision) {
      fetchDivisionRegions(selectedDivision.division_id);
    } else {
      divisionRegionsRequestIdRef.current++;
      setAvailableRegions([]);
      setSelectedRegion(null);
    }
  }, [selectedDivision, fetchDivisionRegions, isLoadingEditData]);



  useEffect(() => {
    const fetchSeries = async () => {
      try {
        const response = await authedFetch(`${API_URL}/series`);
        if (!response.ok) throw new Error('Failed to fetch series');
        const data = await response.json();
        setSeries(data);
      } catch (err) {
        console.error('Failed to load series', err);
      }
    };
    fetchSeries();
  }, []);



  const handleSubmit = async (event) => {
    event.preventDefault();
    if (is_read_only) {
      setAlert({
        show: true,
        message: 'Read-only users cannot modify events',
        severity: 'error',
      });
      return;
    }
    setLoading(true);

    const validationErrors = {};
    if (!eventName.trim()) validationErrors.eventName = 'Event Name is required';
    if (!eventDate || !dayjs(eventDate).isValid()) validationErrors.eventDate = 'Event Date is required';
    if (!selectedTrack) validationErrors.track = 'Track is required';
    if (!selectedDivision) validationErrors.division = 'Division is required';
    if ((pointsType === 'national_and_regional' || pointsType === 'regional_only') && !selectedRegion) {
      validationErrors.region = 'Region is required';
    }
    if (isCancelled && !cancelReason) {
      validationErrors.cancelReason = 'Cancellation Reason is required';
    }

    setAddEventErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setAlert({
        show: true,
        message: 'Please fill in the required fields highlighted below.',
        severity: 'error',
      });
      setLoading(false);
      return;
    }

    try {
      const requestBody = {
        event_name: eventName,
        event_date: eventDate.format('YYYY-MM-DD'),
        track_id: selectedTrack.track_id,
        division_id: selectedDivision.division_id,
        region_id: (pointsType === 'national_and_regional' || pointsType === 'regional_only') && selectedRegion ? selectedRegion.region_id : null,
        season_year: configuredSeasonYear,
        car_count: carCount ? parseInt(carCount, 10) : null,
        notes: notes || null,
        exclude_from_national: pointsType === 'regional_only',
        is_national_points: pointsType !== 'regional_only',
        series_id: selectedSeries ? selectedSeries.series_id : null,
        is_cancelled: isCancelled,
        cancel_reason: isCancelled ? (cancelReason || null) : null
      };

      const response = await authedFetch(`${API_URL}/races`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create event');
      }

      const newEvent = await response.json();

      setAlert({
        show: true,
        message: 'Event created successfully',
        severity: 'success',
      });

      // Close the Add Event dialog
      setOpenDialog(false);

      // Reset form
      resetEventForm();
      
      // Refresh events list
      await fetchEvents();

      // Automatically open the Manage Races dialog for the new event
      setTimeout(() => {
        handleManageRaces(newEvent);
      }, 100); // Small delay to ensure UI updates smoothly
    } catch (error) {
      console.error('Error creating event:', error);
      setAlert({
        show: true,
        message: `Error creating event: ${error.message}`,
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const resetEventForm = () => {
    setEventDate(dayjs());
    setEventName('');
    setSelectedTrack(null);
    setSelectedDivision(null);
    setSelectedRegion(null);
    setCarCount('');
    setNotes('');
    setPointsType('national_and_regional');
    setSelectedSeries(null);
    setIsCancelled(false);
    setCancelReason('');
    setAddEventErrors({});

    setMrpResultsEventId('');
    setMrpResultsLoading(false);
    setMrpPreviewData(null);
    setSelectedMrpDivision('');
  };

  const resetEditEventForm = () => {
    setEditEventName('');
    setEditEventDate(dayjs());
    setEditSelectedTrack(null);
    setEditSelectedDivision(null);
    setEditSelectedRegion(null);
    setEditSeasonYear(configuredSeasonYear);
    setEditCarCount('');
    setEditNotes('');
    setEditPointsType('national_and_regional');
    setEditSelectedSeries(null);
    setEditIsCancelled(false);
    setEditCancelReason('');
    setEditAvailableRegions([]);
  };

  const handleManageRaces = async (event) => {
    setSelectedEvent(event);
    setMrpResultsEventId('');
    setMrpPreviewData(null);
    setSelectedMrpDivision('');
    try {
      // Fetch event races
      const response = await authedFetch(`${API_URL}/races/${event.event_id}/races`);
      const data = await response.json();
      if (data.error) {
        setAlert({
          show: true,
          message: data.error,
          severity: 'error',
        });
        return;
      }
      setEventRaces(data);
      setOpenRacesDialog(true);
    } catch (error) {
      console.error('Error fetching event races:', error);
      setAlert({
        show: true,
        message: 'Error loading event races',
        severity: 'error',
      });
    }
  };

  const handleAddRace = async () => {
    if (is_read_only) {
      setAlert({ show: true, message: 'Read-only users cannot modify races', severity: 'error' });
      return;
    }
    try {
      const response = await authedFetch(`${API_URL}/races/${selectedEvent.event_id}/races`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newRace),
      });

      if (response.ok) {
        const data = await response.json();
        setEventRaces([...eventRaces, data]);
        setOpenNewRaceDialog(false);
        setNewRace({
          race_name: '',
          race_type: 'FEATURE',
          car_count: '',
          notes: '',
          race_order: 1
        });
        
        // Update the event's race status
        setEventsWithRaces(prev => ({
          ...prev,
          [selectedEvent.event_id]: true
        }));
      } else {
        throw new Error('Failed to add race');
      }
    } catch (error) {
      console.error('Error adding race:', error);
      setAlert({
        show: true,
        message: 'Error adding race',
        severity: 'error',
      });
    }
  };

  const handleDeleteRace = async (raceId) => {
    if (is_read_only) {
      setAlert({ show: true, message: 'Read-only users cannot delete races', severity: 'error' });
      return;
    }
    if (!window.confirm('Are you sure you want to delete this race?')) {
      return;
    }

    try {
      const response = await authedFetch(`${API_URL}/races/${selectedEvent.event_id}/races/${raceId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        const updatedRaces = eventRaces.filter(race => race.race_id !== raceId);
        setEventRaces(updatedRaces);
        
        // Update the event's race status based on remaining races
        setEventsWithRaces(prev => ({
          ...prev,
          [selectedEvent.event_id]: updatedRaces.length > 0
        }));
        
        setAlert({
          show: true,
          message: 'Race deleted successfully',
          severity: 'success',
        });
      } else {
        throw new Error('Failed to delete race');
      }
    } catch (error) {
      console.error('Error deleting race:', error);
      setAlert({
        show: true,
        message: 'Error deleting race',
        severity: 'error',
      });
    }
  };

  const handleEditRace = (race) => {
    setEditingRace(race);
    setNewRace({
      race_name: race.race_name,
      race_type: race.race_type,
      car_count: race.car_count,
      notes: race.notes,
      race_order: race.race_order
    });
    setOpenEditRaceDialog(true);
  };

  const handleUpdateRace = async () => {
    if (is_read_only) {
      setAlert({ show: true, message: 'Read-only users cannot modify races', severity: 'error' });
      return;
    }
    try {
      console.log('Updating race with data:', newRace);
      console.log('Event ID:', selectedEvent.event_id);
      console.log('Race ID:', editingRace.race_id);
      
      const response = await authedFetch(`${API_URL}/races/${selectedEvent.event_id}/races/${editingRace.race_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newRace),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
      }

      setAlert({
        show: true,
        message: 'Race updated successfully',
        severity: 'success',
      });

      // Refresh the races list
      await handleManageRaces(selectedEvent);
      
      // Reset form and close dialog
      setNewRace({
        race_name: '',
        race_type: 'FEATURE',
        car_count: '',
        notes: '',
        race_order: 1
      });
      setEditingRace(null);
      setOpenEditRaceDialog(false);
    } catch (error) {
      console.error('Error updating race:', error);
      setAlert({
        show: true,
        message: `Error updating race: ${error.message}`,
        severity: 'error',
      });
    }
  };

  const handleManageResults = async (race) => {
    setSelectedRace(race);
    
    // Clear driver search state from previous race
    setDriverSearchInputs({});
    setDriverSearchResultsMap({});
    setDriverSearchLoadingMap({});
    
    try {
      const response = await authedFetch(`${API_URL}/races/${race.event_id}/races/${race.race_id}/results`);
      const data = await response.json();
      
      const processedResults = data.map(existingResult => ({
        ...existingResult,
        finish_position: existingResult.finish_position?.toString() || '',
        driver_id: existingResult.driver_id || null,
        driver: existingResult.driver_id ? {
          driver_id: existingResult.driver_id,
          car_number: existingResult.car_number,
          first_name: existingResult.first_name,
          last_name: existingResult.last_name
        } : null,
        points_earned: existingResult.points_earned !== null && existingResult.points_earned !== undefined ? existingResult.points_earned : null, // Ensure it's null if not present
        calculated_points: existingResult.points_earned !== null && existingResult.points_earned !== undefined ? existingResult.points_earned : null, // Store initially calculated/fetched points
        manual_points_input: '',
        is_manual_points: false,
        saveError: null // Initialize saveError status
      }));

      const carCountForRace = race.car_count || 24; // Use race-specific car count for rows
      
      // Create a set of existing positions
      const existingPositions = new Set(
        processedResults
          .map(r => parseInt(r.finish_position))
          .filter(p => !isNaN(p))
      );
      
      // Create empty results for missing positions (1 through carCountForRace)
      const emptyResults = [];
      for (let position = 1; position <= carCountForRace; position++) {
        if (!existingPositions.has(position)) {
          emptyResults.push({
            temp_id: `temp-position-${position}`,
            finish_position: position.toString(),
            driver_id: null,
            driver: null,
            points_earned: null,
            status: 'FINISHED',
            notes: '',
            calculated_points: null,
            manual_points_input: '',
            is_manual_points: false,
            saveError: null
          });
        }
      }

      // Merge existing results with empty slots and sort by position
      const mergedResults = [...processedResults, ...emptyResults].sort((a, b) => {
        const posA = parseInt(a.finish_position) || 999;
        const posB = parseInt(b.finish_position) || 999;
        return posA - posB;
      });
      
      // Ensure every row has temp_id if no result_id
      const finalResults = mergedResults.map((result, index) => ({
        ...result,
        temp_id: result.result_id ? undefined : (result.temp_id || `temp-merged-${index}`)
      }));

      // For existing results with drivers, populate the search inputs
      const newDriverSearchInputs = {};
      finalResults.forEach((result, index) => {
        if (result.driver_id && result.driver) {
          newDriverSearchInputs[index] = `${result.driver.car_number} - ${result.driver.first_name} ${result.driver.last_name}`;
        }
      });
      setDriverSearchInputs(newDriverSearchInputs);

      setRaceResults(finalResults);
      setOpenResultsDialog(true);
    } catch (error) {
      console.error('Error fetching race results:', error);
      setAlert({
        show: true,
        message: 'Error loading race results',
        severity: 'error',
      });
    }
  };

  const handleSaveAllResults = async () => {
    if (is_read_only) {
      setAlert({
        show: true,
        message: 'Read-only users cannot save race results',
        severity: 'error',
      });
      return;
    }

    setSavingStatus({ status: 'progress', message: 'Saving race results...' });
    setOpenSavingDialog(true);
    setIsSaving(true);

    console.log('Saving results (raw state):', raceResults); // Debug log of the whole array state

    const resultsToUpdateInState = [...raceResults]; 
    let allSuccessful = true;

    try {
      for (let i = 0; i < resultsToUpdateInState.length; i++) {
        const result = resultsToUpdateInState[i];
        
        if (!result.driver_id || result.finish_position === undefined || result.finish_position === null || result.finish_position === '') {
          console.warn('Skipping result due to missing driver_id or finish_position:', result);
          continue; 
        }

        const payload = {
          driver_id: result.driver_id,
          finish_position: result.finish_position,
          points_earned: result.points_earned !== undefined ? result.points_earned : null,
          status: result.status || 'FINISHED',
          notes: result.notes || '',
          start_position: result.start_position !== undefined ? result.start_position : null,
          laps_completed: result.laps_completed !== undefined ? result.laps_completed : null,
        };

        let url = `${API_URL}/races/${selectedEvent.event_id}/races/${selectedRace.race_id}/results`;
        let method = 'POST';

        if (result.result_id) {
          url += `/${result.result_id}`;
          method = 'PUT';
        }

        console.log(`Sending to ${method} ${url} for index ${i} (prepared payload):`, JSON.stringify(payload, null, 2));

        const response = await authedFetch(url, {
          method: method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          const newOrUpdatedResultFromServer = await response.json();
          console.log(`Received from server for index ${i}:`, newOrUpdatedResultFromServer);
          // Update the item in our mutable copy with the full object from the server
          resultsToUpdateInState[i] = {
            ...resultsToUpdateInState[i], // Preserve any frontend-only state like temp_id if needed
            ...newOrUpdatedResultFromServer, // Override with server data (id, points, etc.)
            driver: { // Ensure driver object is consistent if backend sends flat driver fields
                driver_id: newOrUpdatedResultFromServer.driver_id,
                first_name: newOrUpdatedResultFromServer.first_name, // Assuming backend sends these
                last_name: newOrUpdatedResultFromServer.last_name,
                car_number: newOrUpdatedResultFromServer.car_number
            }
          };
        } else {
          const errorData = await response.json();
          console.error(`Error saving result for index ${i}:`, errorData.error?.message || response.statusText);
          // Set flag and potentially add to an error list to show user
          allSuccessful = false;
          // Update the specific item with an error status if desired for UI feedback
          resultsToUpdateInState[i] = { ...resultsToUpdateInState[i], saveError: errorData.error?.message || 'Save failed' };
          // Optionally, break or continue based on how critical errors are
        }
      }

      if (allSuccessful) {
        setSavingStatus({ status: 'success', message: 'All results saved successfully!' });
      } else {
        setSavingStatus({ status: 'error', message: 'Some results failed to save. Check console for details.' });
      }

    } catch (error) {
      console.error('General error during handleSaveAllResults:', error);
      setSavingStatus({ status: 'error', message: error.message || 'An unexpected error occurred.' });
      allSuccessful = false; // Ensure this is set
    } finally {
      // Update the state with the (potentially) modified results array
      setRaceResults(resultsToUpdateInState);
      setIsSaving(false);
      
      // Close dialog after a short delay, only if not showing a persistent error
      if (savingStatus.status !== 'error' || !allSuccessful) { // check allSuccessful as savingStatus might not be updated yet
         setTimeout(() => {
            if (savingStatus.status !== 'error') { // Re-check in case it changed rapidly
                setOpenSavingDialog(false);
                // Clear status after dialog is closed to prevent "Error" flash
                setTimeout(() => {
                  setSavingStatus({ status: '', message: '' });
                }, 100);

            }
        }, allSuccessful ? 1500 : 3000); // Longer delay if there were errors
      }
    }
  };

  const handleUpdateResult = async (index, field, value) => {
    if (is_read_only) {
      return;
    }

    const updatedResults = [...raceResults];
    // Ensure the item at 'index' exists before trying to update it
    if (!updatedResults[index]) {
        console.warn(`Attempted to update non-existent result at index ${index}`);
        setRaceResults(prevResults => prevResults); // Should not happen, but as a safeguard
        return;
    }
    const currentResultState = { ...updatedResults[index] };

    let shouldRecalculatePoints = false;

    if (field === 'driver') {
      currentResultState.driver = value;
      currentResultState.driver_id = value ? value.driver_id : null;
      currentResultState.car_number = value ? value.car_number : '';
      
      // Recalculate points for Feature, B-Main, and Last Chance races when not in manual mode
      if (!currentResultState.is_manual_points && (selectedRace?.race_type === 'FEATURE' || selectedRace?.race_type === 'B_MAIN' || selectedRace?.race_type === 'LAST_CHANCE')) {
        shouldRecalculatePoints = true;
      }
    } else if (field === 'finish_position') {
      currentResultState.finish_position = value;
      
      // Recalculate points for Feature, B-Main, and Last Chance races when not in manual mode
      if (!currentResultState.is_manual_points && (selectedRace?.race_type === 'FEATURE' || selectedRace?.race_type === 'B_MAIN' || selectedRace?.race_type === 'LAST_CHANCE')) {
        shouldRecalculatePoints = true;
      }
    } else if (field === 'status') {
      currentResultState.status = value;
      
      // Automatically assign 10 points for DNS and DQ
      if (value === 'DNS' || value === 'DQ') {
        currentResultState.points_earned = 10;
        currentResultState.calculated_points = 10;
        // If in manual mode, also update the manual input
        if (currentResultState.is_manual_points) {
          currentResultState.manual_points_input = '10';
        }
      } else if (value === 'FINISHED' || value === 'DNF') {
        // For finished/DNF, recalculate points if not in manual mode
        if (!currentResultState.is_manual_points && currentResultState.finish_position && 
            currentResultState.finish_position.trim() !== '' && 
            (selectedRace?.race_type === 'FEATURE' || selectedRace?.race_type === 'B_MAIN' || selectedRace?.race_type === 'LAST_CHANCE')) {
          shouldRecalculatePoints = true;
        }
      }
    } else if (field === 'is_manual_points') {
      currentResultState.is_manual_points = value; // value is boolean (true/false)
      if (value === true) { // Switched TO manual
        // Pre-fill manual input with current points_earned if it's empty, or keep existing manual_points_input
        currentResultState.manual_points_input = currentResultState.manual_points_input || (currentResultState.points_earned !== null ? currentResultState.points_earned.toString() : '0');
        currentResultState.points_earned = parseFloat(currentResultState.manual_points_input) || 0; // Update points_earned from manual input
              } else { // Switched FROM manual TO auto
          currentResultState.points_earned = currentResultState.calculated_points; // Revert to last calculated points
          // Trigger fresh calculation for Feature, B-Main, and Last Chance races with valid finish position
          if (currentResultState.finish_position && currentResultState.finish_position.trim() !== '' && (selectedRace?.race_type === 'FEATURE' || selectedRace?.race_type === 'B_MAIN' || selectedRace?.race_type === 'LAST_CHANCE')) {
              shouldRecalculatePoints = true;
          }
      }
    } else if (field === 'manual_points_input') {
      currentResultState.manual_points_input = value;
      if (currentResultState.is_manual_points) {
        currentResultState.points_earned = parseFloat(value) || 0; // Update points_earned if in manual mode
        // No need to set shouldRecalculatePoints = true here, as it's manual
      }
    } else {
      currentResultState[field] = value; // For other fields like 'notes'
    }

    updatedResults[index] = currentResultState;
    setRaceResults(updatedResults);

    // Asynchronous points calculation - for Feature, B-Main, and Last Chance races
    if (shouldRecalculatePoints && selectedRace && selectedEvent && currentResultState.finish_position && currentResultState.finish_position.trim() !== '' && (selectedRace.race_type === 'FEATURE' || selectedRace.race_type === 'B_MAIN' || selectedRace.race_type === 'LAST_CHANCE')) {
      try {
        const isFeatureRace = selectedRace.race_type === 'FEATURE';
        const response = await authedFetch(`${API_URL}/points/calculate`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            race_id: selectedRace.race_id,
            position: currentResultState.finish_position,
            car_count: selectedEvent.car_count,
            is_feature: isFeatureRace,
            division_id: selectedEvent.division_id,
            event_date: selectedEvent.event_date,
          }),
        });
        if (response.ok) {
          const data = await response.json();
          setRaceResults(prevResults =>
            prevResults.map((r, i) =>
              i === index ? { ...r, points_earned: data.total_points, calculated_points: data.total_points } : r
            )
          );
        } else {
          const errorData = await response.json();
          // Only show alerts if not currently saving to prevent error flash during save
          if (!isSaving) {
            setAlert({ show: true, message: `Points calculation failed: ${errorData.error || response.statusText}`, severity: 'warning' });
          }
          // Keep existing points_earned, but clear calculated_points to indicate failure?
          setRaceResults(prevResults => prevResults.map((r, i) => i === index ? { ...r, calculated_points: null } : r));
        }
              } catch (error) {
          // Only show alerts if not currently saving to prevent error flash during save
          if (!isSaving) {
            setAlert({ show: true, message: 'Error calculating points', severity: 'error' });
          }
        setRaceResults(prevResults => prevResults.map((r, i) => i === index ? { ...r, calculated_points: null } : r));
      }
    }
  };

  const handleCreateNewDriver = async () => {
    try {
      // Trim and validate required fields
      const trimmedData = {
        first_name: (newDriver.first_name || '').trim(),
        last_name: (newDriver.last_name || '').trim(),
        car_number: (newDriver.car_number || '').trim(),
        hometown: (newDriver.hometown || '').trim(),
        state: newDriver.state || '',
        country: 'US',
        is_current_member: newDriver.is_current_member || false
      };

      // Client-side validation
      if (!trimmedData.first_name || !trimmedData.last_name || !trimmedData.car_number) {
        setAlert({
          show: true,
          message: 'Please fill in all required fields (First Name, Last Name, Car Number)',
          severity: 'error',
        });
        return;
      }

      const response = await authedFetch(`${API_URL}/drivers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(trimmedData),
      });

      // Log the response for debugging
      console.log('API Response Status:', response.status);
      const responseText = await response.text();
      console.log('API Response:', responseText);

      if (!response.ok) {
        let errorMessage = 'Failed to create driver';
        try {
          const errorData = JSON.parse(responseText);
          errorMessage = errorData.error || errorMessage;
        } catch (e) {
          // If response is not JSON, use the raw text
          errorMessage = responseText || errorMessage;
        }
        throw new Error(errorMessage);
      }

      const createdDriver = JSON.parse(responseText);
      
      // Ensure drivers is an array before spreading
      const currentDrivers = Array.isArray(drivers) ? drivers : [];
      setDrivers([...currentDrivers, createdDriver]);
      
      setOpenNewDriverDialog(false);
      setNewDriver({
        first_name: '',
        last_name: '',
        hometown: '',
        state: '',
        country: 'US',
        car_number: '',
        is_current_member: false
      });
      setAlert({
        show: true,
        message: 'Driver created successfully',
        severity: 'success',
      });

      // Update the race results with the new driver
      // Ensure raceResults is an array before spreading
      const currentRaceResults = Array.isArray(raceResults) ? raceResults : [];
      const updatedResults = [...currentRaceResults];
      const index = updatedResults.findIndex(r => !r.driver_id);
      if (index !== -1) {
        updatedResults[index] = {
          ...updatedResults[index],
          driver_id: createdDriver.driver_id,
          car_number: createdDriver.car_number,
          driver: {
            driver_id: createdDriver.driver_id,
            first_name: createdDriver.first_name,
            last_name: createdDriver.last_name,
            car_number: createdDriver.car_number
          }
        };
        setRaceResults(updatedResults);
      }
    } catch (error) {
      console.error('Error creating driver:', error);
      console.error('Error details:', {
        error: error.message,
        stack: error.stack,
        driversState: drivers,
        raceResultsState: raceResults,
        newDriverData: newDriver
      });
      
      // Use handleError for consistency with other error handling in this component
      handleError(error, {
        message: 'Failed to create driver',
        details: error.message || 'Please check the form fields and try again.'
      });
    }
  };

  const handleEditEvent = async (event) => {
    const requestId = ++editEventLoadRequestIdRef.current;
    console.log('handleEditEvent called with event:', event);
    console.log('Current allTracks length:', allTracks.length);
    console.log('Looking for track_id:', event.track_id);

    try {
      setEditingEvent(event);

      // Find all the related objects
      const track = allTracks.find(t => t.track_id === event.track_id) || null;
      const division = divisions.find(d => d.division_id === event.division_id) || null;
      const region = allRegions.find(r => r.region_id === event.region_id) || null;
      const eventSeries = event.series_id ? series.find(s => s.series_id === event.series_id) : null;

      console.log('Found track:', track);
      console.log('Found division:', division);
      console.log('Found region:', region);

      if (division) {
        await fetchEditDivisionRegions(division.division_id, event.season_year);
      }

      if (requestId !== editEventLoadRequestIdRef.current) return;
      
      // Set points type based on event data
      let pointsType = 'national_and_regional';
      if (event.exclude_from_national) {
        pointsType = 'regional_only';
      } else if (!event.region_id) {
        pointsType = 'national_only';
      }
      
      // Populate edit form state (completely separate from add form)
      setEditEventName(event.event_name);
      setEditEventDate(dayjs.utc(event.event_date));
      setEditSelectedTrack(track);
      setEditSelectedDivision(division);
      setEditSelectedRegion(region);
      setEditSeasonYear(event.season_year);
      setEditCarCount(event.car_count?.toString() || '');
      setEditNotes(event.notes || '');
      setEditPointsType(pointsType);
      setEditSelectedSeries(eventSeries || null);
      const isEventCancelled = Boolean(event.is_cancelled);
      setEditIsCancelled(isEventCancelled);
      setEditCancelReason(isEventCancelled ? (event.cancel_reason || 'CANCELLED') : '');
      
      console.log('Set all edit form fields, opening dialog...');
      setOpenEditEventDialog(true);
      
    } catch (error) {
      console.error('Error in handleEditEvent:', error);
      setAlert({
        show: true,
        message: 'Error loading event data for editing',
        severity: 'error'
      });
    }
  };

  const handleUpdateEvent = async () => {
    if (is_read_only) {
      setAlert({
        show: true,
        message: 'Read-only users cannot modify events',
        severity: 'error',
      });
      return;
    }
    console.log('handleUpdateEvent called');
    console.log('Current edit form state:', {
      editEventName,
      editEventDate,
      editSelectedTrack,
      editSelectedDivision,
      editSelectedRegion,
      editCarCount,
      editPointsType,
      editingEvent
    });
    
    setLoading(true);

    // Collect missing required fields
    const missingFields = [];
    if (!editEventName) missingFields.push('Event Name');
    if (!editEventDate) missingFields.push('Event Date');
    if (!editSelectedTrack) missingFields.push('Track');
    if (!editSelectedDivision) missingFields.push('Division');
    if (!editCarCount) missingFields.push('Car Count');
    if ((editPointsType === 'national_and_regional' || editPointsType === 'regional_only') && !editSelectedRegion) {
      missingFields.push('Region');
    }

    if (missingFields.length > 0) {
      console.log('Missing fields:', missingFields);
      setAlert({
        show: true,
        message: `Please fill in the following required fields: ${missingFields.join(', ')}`,
        severity: 'error',
      });
      setLoading(false);
      return;
    }

    try {
      const requestBody = {
        event_name: editEventName,
        event_date: editEventDate.format('YYYY-MM-DD'),
        track_id: editSelectedTrack.track_id,
        division_id: editSelectedDivision.division_id,
        region_id: (editPointsType === 'national_and_regional' || editPointsType === 'regional_only') && editSelectedRegion ? editSelectedRegion.region_id : null,
        season_year: editSeasonYear,
        car_count: editCarCount ? parseInt(editCarCount, 10) : null,
        notes: editNotes || null,
        exclude_from_national: editPointsType === 'regional_only',
        is_national_points: editPointsType !== 'regional_only',
        series_id: editSelectedSeries ? editSelectedSeries.series_id : null,
        is_cancelled: editIsCancelled,
        cancel_reason: editIsCancelled ? (editCancelReason || null) : null
      };

      console.log('Sending update request with body:', requestBody);
      console.log('Update URL:', `${API_URL}/races/${editingEvent.event_id}`);

      const response = await authedFetch(`${API_URL}/races/${editingEvent.event_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      console.log('Response status:', response.status);

      if (!response.ok) {
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          console.log('Error response:', errorData);
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          // Response is not JSON, use the text content
          const errorText = await response.text();
          console.log('Non-JSON error response:', errorText);
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }

      const responseData = await response.json();
      console.log('Success response:', responseData);

      setAlert({
        show: true,
        message: 'Event updated successfully',
        severity: 'success',
      });

      // Close the Edit Event dialog
      setOpenEditEventDialog(false);
      setEditingEvent(null);

      // Reset edit form
      resetEditEventForm();
      
      // Refresh events list
      fetchEvents();
    } catch (error) {
      console.error('Error updating event:', error);
      setAlert({
        show: true,
        message: `Error updating event: ${error.message}`,
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenChangeTrack = (event) => {
    if (is_read_only) {
      setAlert({
        show: true,
        message: 'Read-only users cannot modify events',
        severity: 'error',
      });
      return;
    }
    setChangeTrackEvent(event);
    setChangeTrackSelected(allTracks.find(t => t.track_id === event.track_id) || null);
    setOpenChangeTrackDialog(true);
  };

  const handleCloseChangeTrack = () => {
    setOpenChangeTrackDialog(false);
    setChangeTrackEvent(null);
    setChangeTrackSelected(null);
  };

  const handleConfirmChangeTrack = async () => {
    if (is_read_only) {
      setAlert({ show: true, message: 'Read-only users cannot modify events', severity: 'error' });
      return;
    }
    if (!changeTrackEvent || !changeTrackSelected) {
      setAlert({ show: true, message: 'Please select a track', severity: 'error' });
      return;
    }
    if (changeTrackSelected.track_id === changeTrackEvent.track_id) {
      setAlert({ show: true, message: 'That is already the event’s track — no change made', severity: 'info' });
      handleCloseChangeTrack();
      return;
    }

    setChangeTrackSaving(true);
    try {
      const response = await authedFetch(`${API_URL}/races/${changeTrackEvent.event_id}/track`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ track_id: changeTrackSelected.track_id }),
      });

      if (!response.ok) {
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch (parseError) {
          /* response not JSON; keep status message */
        }
        throw new Error(errorMessage);
      }

      setAlert({
        show: true,
        message: `Track changed to ${changeTrackSelected.track_name} for "${changeTrackEvent.event_name}"`,
        severity: 'success',
      });
      handleCloseChangeTrack();
      fetchEvents();
    } catch (error) {
      console.error('Error changing event track:', error);
      setAlert({
        show: true,
        message: `Error changing track: ${error.message}`,
        severity: 'error',
      });
    } finally {
      setChangeTrackSaving(false);
    }
  };

  const handleDeleteEvent = async (eventId) => {
    if (is_read_only) {
      setAlert({
        show: true,
        message: 'Read-only users cannot delete events',
        severity: 'error',
      });
      return;
    }
    if (!window.confirm('Are you sure you want to delete this event? This will delete all races and results associated with this event.')) {
      return;
    }

    try {
      const response = await authedFetch(`${API_URL}/races/${eventId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setEvents(events.filter(event => event.event_id !== eventId));
        setAlert({
          show: true,
          message: 'Event deleted successfully',
          severity: 'success',
        });
      } else {
        const errorData = await response.text();
        throw new Error(errorData);
      }
    } catch (error) {
      console.error('Error deleting event:', error);
      setAlert({
        show: true,
        message: `Error deleting event: ${error.message}`,
        severity: 'error',
      });
    }
  };

  const columns = [
    {
      field: 'status',
      headerName: '',
      width: 50,
      renderCell: (params) => {
        const hasRaces = eventsWithRaces[params.row.event_id];
        const isCancelledRow = Boolean(params.row.is_cancelled);
        const cancelLabel = params.row.cancel_reason === 'RAINED_OUT' ? 'Rained Out' : 'Cancelled';
        if (isCancelledRow) {
          return (
            <Tooltip title={`Event ${cancelLabel.toLowerCase()}`}>
              <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <CloseIcon color="error" sx={{ fontSize: 18 }} />
              </Box>
            </Tooltip>
          );
        }
        if (hasRaces === false) {
          return (
            <Tooltip title="This event has no races configured">
              <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <ErrorOutlineIcon color="warning" sx={{ fontSize: 18 }} />
              </Box>
            </Tooltip>
          );
        }
        if (hasRaces === true) {
          return (
            <Tooltip title="Event has races configured">
              <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <CheckCircleOutlineIcon color="success" sx={{ fontSize: 18 }} />
              </Box>
            </Tooltip>
          );
        }
        return null; // Still loading
      },
      sortable: false,
      filterable: false,
    },
    {
      field: 'event_date',
      headerName: 'Date',
      flex: 0.7,
      minWidth: 130,
      valueFormatter: (params) => {
        if (!params || !params.value) return '';
        const eventDate = dayjs.utc(params.value);
        return eventDate.format('MMM D, YYYY');
      },
    },
    {
      field: 'track_name',
      headerName: 'Track',
      flex: 2,
      minWidth: 200,
      valueGetter: (params) => {
        if (!params || !params.row) return '';
        return `${params.row.track_name} (${params.row.track_city}, ${params.row.track_state})`;
      },
    },
    {
      field: 'division_name',
      headerName: 'Division',
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'region_name',
      headerName: 'Region',
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: 'season_year',
      headerName: 'Season',
      flex: 0.4,
      minWidth: 70,
    },
    {
      field: 'car_count',
      headerName: 'Cars',
      flex: 0.3,
      minWidth: 60,
    },
    {
      field: 'feature_winner',
      headerName: 'Feature Winner',
      flex: 1.5,
      minWidth: 150,
      valueGetter: (params) => {
        if (!params || !params.row) return '';
        return featureWinners[params.row.event_id] || '';
      },
      renderCell: (params) => {
        const winner = featureWinners[params.row.event_id];
        if (!winner) {
          return <Typography variant="body2" color="text.secondary">-</Typography>;
        }
        return (
          <Tooltip title={winner}>
            <Typography variant="body2" noWrap>
              {winner}
            </Typography>
          </Tooltip>
        );
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1.2,
      minWidth: 180,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Tooltip title={params.row.is_cancelled ? 'Cancelled events cannot have races or results' : 'Manage races'}>
            <span>
              <Button
                onClick={() => handleManageRaces(params.row)}
                variant="text"
                size="small"
                sx={{ minWidth: 'auto', px: 1, fontSize: '0.75rem', fontWeight: 500 }}
                disabled={Boolean(params.row.is_cancelled)}
              >
                Races
              </Button>
            </span>
          </Tooltip>
          <Tooltip title="Edit event">
            <IconButton
              onClick={() => handleEditEvent(params.row)}
              size="small"
              disabled={is_read_only}
              sx={{ p: 0.5, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Change track (quick correction)">
            <IconButton
              onClick={() => handleOpenChangeTrack(params.row)}
              size="small"
              disabled={is_read_only}
              sx={{ p: 0.5, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
            >
              <EditLocationAltIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete event">
            <IconButton
              onClick={() => handleDeleteEvent(params.row.event_id)}
              size="small"
              disabled={is_read_only}
              sx={{ p: 0.5, color: 'text.secondary', '&:hover': { color: 'error.main' } }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  // Debounced search function
  const fetchDriverSearchResults = useCallback(
    debounce(async (input, rowIndex) => {
      setDriverSearchLoadingMap(prev => ({ ...prev, [rowIndex]: true }));
      try {
        const response = await authedFetch(`${API_URL}/drivers/search?query=${encodeURIComponent(input)}&limit=20`);
        const data = await response.json();
        setDriverSearchResultsMap(prev => ({ ...prev, [rowIndex]: data.drivers || [] }));
      } catch (error) {
        setDriverSearchResultsMap(prev => ({ ...prev, [rowIndex]: [] }));
      } finally {
        setDriverSearchLoadingMap(prev => ({ ...prev, [rowIndex]: false }));
      }
    }, 300),
    []
  );

  const handleDivisionChange = (event) => {
    const divisionId = event.target.value;
    const division = divisions.find(d => d.division_id === divisionId);
    divisionRegionsRequestIdRef.current++;
    setSelectedDivision(division || null);
    setSelectedRegion(null);
    setAvailableRegions([]);
    setAddEventErrors(prev => {
      const next = { ...prev };
      delete next.division;
      delete next.region;
      return next;
    });
  };

  const handleEditDivisionChange = (event) => {
    const divisionId = event.target.value;
    const division = divisions.find(d => d.division_id === divisionId);
    editDivisionRegionsRequestIdRef.current++;
    setEditSelectedDivision(division || null);
    setEditSelectedRegion(null);
    setEditAvailableRegions([]);
    if (divisionId) {
      fetchEditDivisionRegions(divisionId);
    }
  };

  const calculateStats = (eventsData) => {
    const totalEvents = eventsData.length;
    const totalCars = eventsData.reduce((sum, event) => sum + (event.car_count || 0), 0);
    const uniqueTracks = new Set(eventsData.map(event => event.track_id)).size;
    const averageCarsPerEvent = totalEvents > 0 ? Math.round(totalCars / totalEvents) : 0;

    setStats({
      totalEvents,
      totalCars,
      uniqueTracks,
      averageCarsPerEvent
    });
  };

  useEffect(() => {
    let filtered = [...events];
    if (configuredSeasonYear) {
      filtered = filtered.filter(event => event.season_year === configuredSeasonYear);
    }
    if (filterDivision) {
      filtered = filtered.filter(event => event.division_id === filterDivision);
    }
    if (filterRegion) {
      filtered = filtered.filter(event => event.region_id === filterRegion);
    }
    if (filterTrack) {
      filtered = filtered.filter(event => event.track_id === filterTrack);
    }
    if (startDate && endDate) {
      filtered = filtered.filter(event => {
        const eventDate = dayjs.utc(event.event_date);
        const start = dayjs.utc(startDate);
        const end = dayjs.utc(endDate);
        return eventDate.isAfter(start.subtract(1, 'day')) &&
               eventDate.isBefore(end.add(1, 'day'));
      });
    }
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(event =>
        event.event_name?.toLowerCase().includes(query) ||
        event.track_name?.toLowerCase().includes(query) ||
        event.division_name?.toLowerCase().includes(query) ||
        event.region_name?.toLowerCase().includes(query) ||
        (event.is_cancelled ? (event.cancel_reason === 'RAINED_OUT' ? 'rained out' : 'cancelled') : 'active').includes(query)
      );
    }
    setFilteredEvents(filtered);
    calculateStats(filtered);
  }, [events, configuredSeasonYear, filterDivision, filterRegion, filterTrack, startDate, endDate, searchQuery]);

  const fetchDivisionRegionsForFilter = useCallback(async (divisionId, { resetSelection = true } = {}) => {
    const requestId = ++filterDivisionRegionsRequestIdRef.current;
    try {
      const response = await authedFetch(
        `${API_URL}/division-regions/${divisionId}?season_year=${configuredSeasonYear}`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch division regions');
      }
      const data = await response.json();
      if (requestId !== filterDivisionRegionsRequestIdRef.current) return;

      const filteredRegions = allRegions.filter(region =>
        data.some(dr => dr.region_id === region.region_id)
      );

      setAvailableFilterRegions(filteredRegions);
      if (resetSelection) {
        setFilterRegion('');
      } else {
        setFilterRegion(prev => (filteredRegions.some(r => r.region_id === prev) ? prev : ''));
      }
    } catch (error) {
      if (requestId !== filterDivisionRegionsRequestIdRef.current) return;
      console.error('Error fetching division regions:', error);
      setAlert({
        show: true,
        message: 'Error loading regions for division',
        severity: 'error',
      });
      setAvailableFilterRegions([]);
      setFilterRegion('');
    }
  }, [allRegions, configuredSeasonYear]);

  const exportToExcel = () => {
    try {
      // Prepare data for export
      const exportData = filteredEvents.map(event => ({
        'Event ID': event.event_id,
        'Event Name': event.event_name,
        'Date': dayjs.utc(event.event_date).format('MM/DD/YYYY'),
        'Track': `${event.track_name} (${event.track_city}, ${event.track_state})`,
        'Division': event.division_name,
        'Region': event.region_name || 'N/A',
        'Series': event.series_name || 'N/A',
        'Season': event.season_year,
        'Car Count': event.car_count || 0,
        'Has Races': eventsWithRaces[event.event_id] ? 'Yes' : 'No',
        'Feature Winner(s)': featureWinners[event.event_id] || 'N/A',
        'National Points': event.exclude_from_national ? 'No' : 'Yes',
        'Status': event.is_cancelled ? (event.cancel_reason === 'RAINED_OUT' ? 'Rained Out' : 'Cancelled') : 'Active',
        'Cancellation Reason': event.is_cancelled ? (event.cancel_reason || 'Cancelled') : '',
        'Notes': event.notes || ''
      }));

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Auto-size columns
      const colWidths = Object.keys(exportData[0] || {}).map(key => {
        const maxLength = Math.max(
          key.length,
          ...exportData.map(row => String(row[key] || '').length)
        );
        return { wch: Math.min(maxLength + 2, 50) };
      });
      ws['!cols'] = colWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Race Events');

      // Generate filename with current date
      const fileName = `race-events-export-${dayjs().format('YYYY-MM-DD')}.xlsx`;

      // Export file
      XLSX.writeFile(wb, fileName);

      setAlert({
        show: true,
        message: `Successfully exported ${exportData.length} events to ${fileName}`,
        severity: 'success',
      });
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      setAlert({
        show: true,
        message: 'Error exporting to Excel. Please try again.',
        severity: 'error',
      });
    }
  };

  const exportToCSV = () => {
    try {
      // Prepare data for export
      const exportData = filteredEvents.map(event => ({
        'Event ID': event.event_id,
        'Event Name': event.event_name,
        'Date': dayjs.utc(event.event_date).format('MM/DD/YYYY'),
        'Track': `${event.track_name} (${event.track_city}, ${event.track_state})`,
        'Division': event.division_name,
        'Region': event.region_name || 'N/A',
        'Series': event.series_name || 'N/A',
        'Season': event.season_year,
        'Car Count': event.car_count || 0,
        'Has Races': eventsWithRaces[event.event_id] ? 'Yes' : 'No',
        'Feature Winner(s)': featureWinners[event.event_id] || 'N/A',
        'National Points': event.exclude_from_national ? 'No' : 'Yes',
        'Status': event.is_cancelled ? (event.cancel_reason === 'RAINED_OUT' ? 'Rained Out' : 'Cancelled') : 'Active',
        'Cancellation Reason': event.is_cancelled ? (event.cancel_reason || 'Cancelled') : '',
        'Notes': event.notes || ''
      }));

      // Convert to CSV
      const headers = Object.keys(exportData[0] || {});
      const csvContent = [
        headers.join(','),
        ...exportData.map(row => 
          headers.map(header => {
            const value = String(row[header] || '');
            // Escape quotes and wrap in quotes if contains comma, quote, or newline
            return value.includes(',') || value.includes('"') || value.includes('\n') 
              ? `"${value.replace(/"/g, '""')}"` 
              : value;
          }).join(',')
        )
      ].join('\n');

      // Create and download file
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const fileName = `race-events-export-${dayjs().format('YYYY-MM-DD')}.csv`;
      saveAs(blob, fileName);

      setAlert({
        show: true,
        message: `Successfully exported ${exportData.length} events to ${fileName}`,
        severity: 'success',
      });
    } catch (error) {
      console.error('Error exporting to CSV:', error);
      setAlert({
        show: true,
        message: 'Error exporting to CSV. Please try again.',
        severity: 'error',
      });
    }
  };

  const handleFilterDivisionChange = (event) => {
    const divisionId = event.target.value;
    filterDivisionRegionsRequestIdRef.current++;
    setFilterDivision(divisionId);
    setFilterRegion('');
    setAvailableFilterRegions([]);
  };

  useEffect(() => {
    if (filterDivision) {
      fetchDivisionRegionsForFilter(filterDivision, { resetSelection: false });
    } else {
      filterDivisionRegionsRequestIdRef.current++;
      setAvailableFilterRegions([]);
      setFilterRegion('');
    }
  }, [filterDivision, configuredSeasonYear, fetchDivisionRegionsForFilter]);

  useEffect(() => {
    raceResults.forEach((result, index) => {
      if (
        result.driver_id &&
        !driverSearchResultsMap[index]?.some(d => d.driver_id === result.driver.driver_id) &&
        !driverCache.current[result.driver_id]
      ) {
        authedFetch(`${API_URL}/drivers/search?query=${result.driver_id}&limit=1`)
          .then(res => res.json())
          .then(data => {
            const driver = (data.drivers || []).find(d => d.driver_id === result.driver_id);
            if (driver) {
              driverCache.current[result.driver_id] = driver;
              setDriverSearchResultsMap(prev => ({
                ...prev,
                [index]: prev[index] ? [driver, ...prev[index]] : [driver]
              }));
            }
          });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [raceResults, driverSearchResultsMap]);

  return (
    <Box>
      <Box
        sx={{
          mb: 3,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'stretch', md: 'center' },
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h4" component="h1">
            Race Entry
          </Typography>
          <Button
            onClick={(e) => setSeasonAnchorEl(e.currentTarget)}
            endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
            sx={{
              borderRadius: 9999,
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'background.paper',
              color: 'text.primary',
              fontWeight: 500,
              fontSize: '0.8125rem',
              py: 0.25,
              px: 1.5,
              minHeight: 28,
              '&:hover': { backgroundColor: 'action.hover', borderColor: 'text.disabled' }
            }}
          >
            <Typography component="span" variant="caption" color="text.secondary" sx={{ mr: 0.75, fontWeight: 500 }}>
              Season
            </Typography>
            <Typography component="span" variant="body2" sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
              {configuredSeasonYear}
            </Typography>
          </Button>
          <Menu
            anchorEl={seasonAnchorEl}
            open={Boolean(seasonAnchorEl)}
            onClose={() => setSeasonAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            slotProps={{ paper: { sx: { mt: 0.5, minWidth: 100 } } }}
          >
            {[...new Set(events.map(e => e.season_year))]
              .filter((y) => y)
              .sort((a, b) => b - a)
              .map((y) => (
                <MenuItem
                  key={y}
                  selected={y === configuredSeasonYear}
                  onClick={() => {
                    setGlobalSeasonYear(y);
                    setSeasonAnchorEl(null);
                  }}
                >
                  {y}
                </MenuItem>
              ))}
          </Menu>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={(e) => setExportAnchorEl(e.currentTarget)}
            disabled={filteredEvents.length === 0}
            startIcon={<FileDownloadIcon sx={{ fontSize: 16 }} />}
            endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
          >
            Export
          </Button>
          <Menu
            anchorEl={exportAnchorEl}
            open={Boolean(exportAnchorEl)}
            onClose={() => setExportAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            slotProps={{ paper: { sx: { mt: 0.5, minWidth: 140 } } }}
          >
            <MenuItem onClick={() => { setExportAnchorEl(null); exportToExcel(); }}>
              Excel (.xlsx)
            </MenuItem>
            <MenuItem onClick={() => { setExportAnchorEl(null); exportToCSV(); }}>
              CSV
            </MenuItem>
          </Menu>
          <Button
            variant="contained"
            onClick={() => {
              setAddEventErrors({});
              setOpenDialog(true);
            }}
            startIcon={<AddIcon />}
            disabled={is_read_only}
          >
            Add New Event
          </Button>
        </Box>
      </Box>

      {/* Statistics Cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[
          { label: 'Total Events', value: stats.totalEvents, icon: <FlagIcon /> },
          { label: 'Total Cars', value: stats.totalCars, icon: <DirectionsCarIcon /> },
          { label: 'Unique Tracks', value: stats.uniqueTracks, icon: <LocationOnIcon /> },
          { label: 'Avg Cars per Event', value: stats.averageCarsPerEvent, icon: <SpeedIcon /> }
        ].map((stat) => (
          <Grid key={stat.label} item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%' }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    sx={{ letterSpacing: '0.04em', fontWeight: 500, lineHeight: 1.2 }}
                  >
                    {stat.label}
                  </Typography>
                  <Box sx={{ color: 'text.disabled', display: 'flex', alignItems: 'center', '& svg': { fontSize: 18 } }}>
                    {stat.icon}
                  </Box>
                </Box>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums', lineHeight: 1.1 }}
                >
                  {stat.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Filters */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel>Track</InputLabel>
            <Select
              value={filterTrack}
              onChange={(e) => setFilterTrack(e.target.value)}
              label="Track"
            >
              <MenuItem value="">All Tracks</MenuItem>
              {allTracks.map((track) => (
                <MenuItem key={track.track_id} value={track.track_id}>
                  {track.track_name} ({track.track_city}, {track.track_state})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Division</InputLabel>
            <Select
              value={filterDivision}
              onChange={handleFilterDivisionChange}
              label="Division"
            >
              <MenuItem value="">All Divisions</MenuItem>
              {divisions.map((division) => (
                <MenuItem key={division.division_id} value={division.division_id}>
                  {division.division_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Region</InputLabel>
            <Select
              value={filterRegion}
              onChange={(e) => setFilterRegion(e.target.value)}
              label="Region"
              disabled={!filterDivision}
            >
              <MenuItem value="">All Regions</MenuItem>
              {availableFilterRegions.map((region) => (
                <MenuItem key={region.region_id} value={region.region_id}>
                  {region.region_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={setStartDate}
              slotProps={{ textField: { size: 'small', sx: { minWidth: 140 } } }}
            />
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={setEndDate}
              minDate={startDate}
              slotProps={{ textField: { size: 'small', sx: { minWidth: 140 } } }}
            />
          </LocalizationProvider>
          <TextField
            size="small"
            label="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ minWidth: 200, flexGrow: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Paper>

      {/* Events Table */}
      <Paper sx={{ p: 0, overflow: 'hidden' }}>
        <DataGrid
          rows={filteredEvents}
          getRowId={(row) => row.event_id}
          columns={columns}
          loading={loading}
          disableSelectionOnClick
          autoHeight
          getRowClassName={(params) => {
            const hasRaces = eventsWithRaces[params.row.event_id];
            if (params.row.is_cancelled) {
              return 'event-cancelled';
            }
            return hasRaces === false ? 'event-no-races' : '';
          }}
          sx={{
            border: 'none',
            fontFamily: 'inherit',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'transparent',
              borderBottom: '1px solid',
              borderColor: 'divider',
              minHeight: '40px !important',
              maxHeight: '40px !important',
              lineHeight: '40px !important',
            },
            '& .MuiDataGrid-columnHeader': {
              padding: '0 12px',
              '&:focus, &:focus-within': { outline: 'none' },
              '&:focus-visible': {
                outline: '2px solid',
                outlineColor: 'primary.main',
                outlineOffset: -2,
              },
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: '0.75rem',
              fontWeight: 500,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              color: 'text.secondary',
            },
            '& .MuiDataGrid-columnSeparator': { display: 'none' },
            '& .MuiDataGrid-cell': {
              padding: '0 12px',
              fontSize: '0.875rem',
              color: 'text.primary',
              borderBottom: '1px solid',
              borderColor: 'grey.100',
              '&:focus, &:focus-within': { outline: 'none' },
              '&:focus-visible': {
                outline: '2px solid',
                outlineColor: 'primary.main',
                outlineOffset: -2,
              },
            },
            '& .MuiDataGrid-row': {
              transition: 'background-color 120ms',
              '&:hover': { backgroundColor: 'action.hover' },
            },
            '& .MuiDataGrid-row:last-of-type .MuiDataGrid-cell': {
              borderBottom: 'none',
            },
            '& .event-cancelled': {
              opacity: 0.65,
              '& .MuiDataGrid-cell': { color: 'text.secondary' },
            },
            '& .event-no-races': {
              backgroundColor: 'rgba(245, 158, 11, 0.04)',
              '&:hover': { backgroundColor: 'rgba(245, 158, 11, 0.08)' },
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: '1px solid',
              borderColor: 'divider',
              minHeight: '44px',
            },
            '& .MuiTablePagination-root': {
              fontSize: '0.8125rem',
            },
          }}
        />
      </Paper>

      {/* Add Event Dialog */}
      <Dialog 
        open={openDialog} 
        onClose={() => {
          setAddEventErrors({});
          setOpenDialog(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Add New Event
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ pt: 1 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Event Name"
                  value={eventName}
                  onChange={(e) => {
                    setEventName(e.target.value);
                    if (addEventErrors.eventName && e.target.value.trim()) {
                      setAddEventErrors(prev => {
                        const next = { ...prev };
                        delete next.eventName;
                        return next;
                      });
                    }
                  }}
                  required
                  variant="outlined"
                  autoFocus
                  aria-label="Event Name"
                  error={Boolean(addEventErrors.eventName)}
                  helperText={addEventErrors.eventName || ''}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Event Date"
                    value={eventDate}
                    onChange={(newValue) => {
                      setEventDate(newValue);
                      if (addEventErrors.eventDate && newValue && dayjs(newValue).isValid()) {
                        setAddEventErrors(prev => {
                          const next = { ...prev };
                          delete next.eventDate;
                          return next;
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="outlined"
                        required
                        aria-label="Event Date"
                        error={Boolean(addEventErrors.eventDate) || params.error}
                        helperText={addEventErrors.eventDate || params.helperText}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined" required error={Boolean(addEventErrors.division)}>
                  <InputLabel>Division</InputLabel>
                  <Select
                    value={selectedDivision?.division_id || ''}
                    label="Division"
                    onChange={handleDivisionChange}
                    aria-label="Division"
                  >
                    {divisions.map((division) => (
                      <MenuItem key={division.division_id} value={division.division_id}>
                        {division.division_name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{addEventErrors.division || ' '}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend">Event Points Type</FormLabel>
                  <RadioGroup
                    row
                    value={pointsType}
                    onChange={e => {
                      setPointsType(e.target.value);
                      // If switching to national_only, clear region
                      if (e.target.value === 'national_only') {
                        setSelectedRegion(null);
                        setAddEventErrors(prev => {
                          const next = { ...prev };
                          delete next.region;
                          return next;
                        });
                      }
                    }}
                    aria-label="Event Points Type"
                    name="points-type"
                  >
                    <MuiFormControlLabel value="national_and_regional" control={<Radio />} label="National & Regional" />
                    <MuiFormControlLabel value="national_only" control={<Radio />} label="National Only" />
                    <MuiFormControlLabel value="regional_only" control={<Radio />} label="Regional Only" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {(pointsType === 'national_and_regional' || pointsType === 'regional_only') && (
                <Grid item xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    required
                    error={Boolean(addEventErrors.region) || (Boolean(selectedDivision) && availableRegions.length === 0)}
                  >
                    <InputLabel>Region</InputLabel>
                    <Select
                      value={selectedRegion?.region_id || ''}
                      label="Region"
                      onChange={(e) => {
                        const region = availableRegions.find(r => r.region_id === e.target.value);
                        setSelectedRegion(region);
                        if (region) {
                          setAddEventErrors(prev => {
                            const next = { ...prev };
                            delete next.region;
                            return next;
                          });
                        }
                      }}
                      disabled={!selectedDivision}
                      aria-label="Region"
                    >
                      {availableRegions.map((region) => (
                        <MenuItem key={region.region_id} value={region.region_id}>
                          {region.region_name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {addEventErrors.region
                        || (selectedDivision && availableRegions.length === 0
                          ? `No regions configured for this division in ${configuredSeasonYear}. Switch to "National Only" or assign a region to this division in Season Setup.`
                          : ' ')}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isCancelled}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setIsCancelled(checked);
                        setAddEventErrors(prev => {
                          const next = { ...prev };
                          delete next.cancelReason;
                          return next;
                        });
                        if (checked && !cancelReason) {
                          setCancelReason('RAINED_OUT');
                        }
                        if (!checked) {
                          setCancelReason('');
                        }
                      }}
                      color="error"
                    />
                  }
                  label="Cancelled / Rained Out"
                />
              </Grid>
              {isCancelled && (
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" required error={Boolean(addEventErrors.cancelReason)}>
                    <InputLabel>Cancellation Reason</InputLabel>
                    <Select
                      value={cancelReason}
                      label="Cancellation Reason"
                      onChange={(e) => {
                        setCancelReason(e.target.value);
                        if (e.target.value) {
                          setAddEventErrors(prev => {
                            const next = { ...prev };
                            delete next.cancelReason;
                            return next;
                          });
                        }
                      }}
                      aria-label="Cancellation Reason"
                    >
                      {cancelReasonOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{addEventErrors.cancelReason || ' '}</FormHelperText>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Series (Optional)</InputLabel>
                  <Select
                    value={selectedSeries?.series_id || ''}
                    label="Series (Optional)"
                    onChange={e => {
                      const s = series.find(s => s.series_id === e.target.value);
                      setSelectedSeries(s || null);
                    }}
                    disabled={!selectedDivision}
                    aria-label="Series"
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {series.filter(s => s.division_id === selectedDivision?.division_id && s.season_year === configuredSeasonYear)
                      .map(s => (
                        <MenuItem key={s.series_id} value={s.series_id}>{s.series_name}</MenuItem>
                      ))}
                  </Select>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                    Optional: Assign this event to a series (if applicable)
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  value={selectedTrack}
                  onChange={(event, newValue) => {
                    setSelectedTrack(newValue);
                    if (newValue) {
                      setAddEventErrors(prev => {
                        const next = { ...prev };
                        delete next.track;
                        return next;
                      });
                    }
                    if (newValue) {
                      setCarCount(''); // Reset car count when track changes
                    }
                  }}
                  options={tracks}
                  getOptionLabel={(option) => 
                    option ? `${option.track_name} - ${option.track_city}, ${option.track_state}` : ''
                  }
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      label="Track"
                      required
                      error={Boolean(addEventErrors.track)}
                      helperText={addEventErrors.track || ''}
                      variant="outlined"
                      aria-label="Track"
                    />
                  )}
                  isOptionEqualToValue={(option, value) => 
                    option.track_id === value.track_id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={<span>Car Count <Tooltip title="This is the official car count for the event and is used for points calculation."><span style={{ cursor: 'help', color: '#1976d2' }}>ⓘ</span></Tooltip></span>}
                  type="number"
                  value={carCount}
                  onChange={(e) => setCarCount(e.target.value)}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <DirectionsCarIcon sx={{ fontSize: 18, color: 'text.disabled' }} />
                      </InputAdornment>
                    ),
                    inputProps: { min: 0, 'aria-label': 'Car Count' }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Notes (Optional)"
                  multiline
                  rows={3}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  variant="outlined"
                  aria-label="Notes"
                  helperText="Optional: Add any special notes about this event."
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => {
            setAddEventErrors({});
            setOpenDialog(false);
          }} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary" size="large" sx={{ minWidth: 140 }} disabled={loading || is_read_only} startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}>
            Add Event
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Event Dialog */}
      <Dialog 
        open={openEditEventDialog} 
        onClose={() => {
          setOpenEditEventDialog(false);
          setEditingEvent(null);
          resetEditEventForm();
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Edit Event
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ pt: 1 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Event Name"
                  value={editEventName}
                  onChange={(e) => setEditEventName(e.target.value)}
                  required
                  variant="outlined"
                  autoFocus
                  aria-label="Event Name"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Event Date"
                    value={editEventDate}
                    onChange={(newValue) => setEditEventDate(newValue)}
                    renderInput={(params) => <TextField {...params} fullWidth variant="outlined" required aria-label="Event Date" />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined" required>
                  <InputLabel>Division</InputLabel>
                  <Select
                    value={editSelectedDivision?.division_id || ''}
                    label="Division"
                    onChange={handleEditDivisionChange}
                    aria-label="Division"
                  >
                    {divisions.map((division) => (
                      <MenuItem key={division.division_id} value={division.division_id}>
                        {division.division_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend">Event Points Type</FormLabel>
                  <RadioGroup
                    row
                    value={editPointsType}
                    onChange={e => {
                      setEditPointsType(e.target.value);
                      // If switching to national_only, clear region
                      if (e.target.value === 'national_only') {
                        setEditSelectedRegion(null);
                      }
                    }}
                    aria-label="Event Points Type"
                    name="points-type"
                  >
                    <MuiFormControlLabel value="national_and_regional" control={<Radio />} label="National & Regional" />
                    <MuiFormControlLabel value="national_only" control={<Radio />} label="National Only" />
                    <MuiFormControlLabel value="regional_only" control={<Radio />} label="Regional Only" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {(editPointsType === 'national_and_regional' || editPointsType === 'regional_only') && (
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel>Region</InputLabel>
                    <Select
                      value={editSelectedRegion?.region_id || ''}
                      label="Region"
                      onChange={(e) => {
                        const region = editAvailableRegions.find(r => r.region_id === e.target.value);
                        setEditSelectedRegion(region);
                      }}
                      disabled={!editSelectedDivision}
                      aria-label="Region"
                    >
                      {editAvailableRegions.map((region) => (
                        <MenuItem key={region.region_id} value={region.region_id}>
                          {region.region_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={editIsCancelled}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setEditIsCancelled(checked);
                        if (checked && !editCancelReason) {
                          setEditCancelReason('RAINED_OUT');
                        }
                        if (!checked) {
                          setEditCancelReason('');
                        }
                      }}
                      color="error"
                    />
                  }
                  label="Cancelled / Rained Out"
                />
              </Grid>
              {editIsCancelled && (
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel>Cancellation Reason</InputLabel>
                    <Select
                      value={editCancelReason}
                      label="Cancellation Reason"
                      onChange={(e) => setEditCancelReason(e.target.value)}
                      aria-label="Cancellation Reason"
                    >
                      {cancelReasonOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Series (Optional)</InputLabel>
                  <Select
                    value={editSelectedSeries?.series_id || ''}
                    label="Series (Optional)"
                    onChange={e => {
                      const s = series.find(s => s.series_id === e.target.value);
                      setEditSelectedSeries(s || null);
                    }}
                    disabled={!editSelectedDivision}
                    aria-label="Series"
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {series.filter(s => s.division_id === editSelectedDivision?.division_id && s.season_year === editSeasonYear)
                      .map(s => (
                        <MenuItem key={s.series_id} value={s.series_id}>{s.series_name}</MenuItem>
                      ))}
                  </Select>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                    Optional: Assign this event to a series (if applicable)
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  value={editSelectedTrack}
                  onChange={(event, newValue) => {
                    setEditSelectedTrack(newValue);
                    if (newValue) {
                      setEditCarCount(''); // Reset car count when track changes
                    }
                  }}
                  options={allTracks}
                  getOptionLabel={(option) => 
                    option ? `${option.track_name} - ${option.track_city}, ${option.track_state}` : ''
                  }
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      label="Track"
                      required
                      error={!editSelectedTrack}
                      helperText={!editSelectedTrack ? 'Track is required' : ''}
                      variant="outlined"
                      aria-label="Track"
                    />
                  )}
                  isOptionEqualToValue={(option, value) => 
                    option.track_id === value.track_id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={<span>Car Count <Tooltip title="This is the official car count for the event and is used for points calculation."><span style={{ cursor: 'help', color: '#1976d2' }}>ⓘ</span></Tooltip></span>}
                  type="number"
                  value={editCarCount}
                  onChange={(e) => setEditCarCount(e.target.value)}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <DirectionsCarIcon sx={{ fontSize: 18, color: 'text.disabled' }} />
                      </InputAdornment>
                    ),
                    inputProps: { min: 0, 'aria-label': 'Car Count' }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Notes (Optional)"
                  multiline
                  rows={3}
                  value={editNotes}
                  onChange={(e) => setEditNotes(e.target.value)}
                  variant="outlined"
                  aria-label="Notes"
                  helperText="Optional: Add any special notes about this event."
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => {
            setOpenEditEventDialog(false);
            setEditingEvent(null);
            resetEditEventForm();
          }} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleUpdateEvent} variant="contained" color="primary" size="large" sx={{ minWidth: 140 }} disabled={loading || is_read_only} startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}>
            Update Event
          </Button>
        </DialogActions>
      </Dialog>

      {/* Change Track Dialog (focused correction) */}
      <Dialog
        open={openChangeTrackDialog}
        onClose={handleCloseChangeTrack}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 0.5 }}>Change Track</DialogTitle>
        <DialogContent>
          {changeTrackEvent && (
            <Box sx={{ pt: 1 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Reassigns only the track for <strong>{changeTrackEvent.event_name}</strong>{' '}
                ({dayjs.utc(changeTrackEvent.event_date).format('MMM D, YYYY')}). Everything
                else — division, region, results and points — stays exactly the same. The
                change is recorded in the audit log.
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                Currently: {changeTrackEvent.track_name || '—'}
              </Typography>
              <Autocomplete
                value={changeTrackSelected}
                onChange={(event, newValue) => setChangeTrackSelected(newValue)}
                options={allTracks}
                getOptionLabel={(option) =>
                  option ? `${option.track_name} - ${option.track_city}, ${option.track_state}` : ''
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="New Track"
                    required
                    error={!changeTrackSelected}
                    helperText={!changeTrackSelected ? 'Track is required' : ''}
                    variant="outlined"
                    aria-label="New Track"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.track_id === value.track_id}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseChangeTrack} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmChangeTrack}
            variant="contained"
            color="primary"
            size="large"
            sx={{ minWidth: 140 }}
            disabled={changeTrackSaving || is_read_only || !changeTrackSelected}
            startIcon={changeTrackSaving ? <CircularProgress size={20} color="inherit" /> : null}
          >
            Change Track
          </Button>
        </DialogActions>
      </Dialog>

      {/* Races Dialog */}
      <Dialog
        open={openRacesDialog}
        onClose={() => setOpenRacesDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pb: 0.5 }}>
          {selectedEvent ? (
            <>Manage Races &mdash; {selectedEvent.event_name}</>
          ) : 'Manage Races'}
        </DialogTitle>
        {selectedEvent && (
          <Box sx={{ px: 3, pb: 1 }}>
            <Typography variant="caption" color="text.secondary">
              {dayjs.utc(selectedEvent.event_date).format('MMM D, YYYY')} &middot; {selectedEvent.track_name}
            </Typography>
          </Box>
        )}
        <DialogContent sx={{ pt: 1 }}>
          {Boolean(selectedEvent?.is_cancelled) && (
            <Alert severity="error" sx={{ mb: 2 }}>
              This event is cancelled and cannot have races or results.
            </Alert>
          )}
          <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setOpenNewRaceDialog(true)}
              disabled={is_read_only || Boolean(selectedEvent?.is_cancelled)}
            >
              Add Race
            </Button>
            {eventRaces.length > 0 && (
              <Typography variant="caption" color="text.secondary">
                {eventRaces.length} {eventRaces.length === 1 ? 'race' : 'races'}
              </Typography>
            )}
          </Box>
          <List disablePadding sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
            {eventRaces.map((race, index) => (
              <React.Fragment key={race.race_id}>
                {index > 0 && <Divider />}
                <ListItem
                  sx={{
                    py: 1.25,
                    px: 2,
                    transition: 'background-color 120ms',
                    '&:hover': { backgroundColor: 'action.hover' }
                  }}
                >
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" fontWeight={600}>
                          {race.race_name}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            px: 0.75,
                            py: 0.125,
                            borderRadius: 9999,
                            backgroundColor: 'grey.100',
                            color: 'text.secondary',
                            textTransform: 'uppercase',
                            letterSpacing: '0.04em',
                            fontWeight: 500
                          }}
                        >
                          {raceTypes.find((t) => t.value === race.race_type)?.label}
                        </Typography>
                      </Box>
                    }
                    secondary={`${race.car_count || 0} cars`}
                    secondaryTypographyProps={{ variant: 'caption' }}
                  />
                  <ListItemSecondaryAction>
                    <Tooltip title="View results">
                      <IconButton
                        size="small"
                        aria-label="manage results"
                        onClick={() => handleManageResults(race)}
                        sx={{ mr: 0.25, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit race">
                      <IconButton
                        size="small"
                        aria-label="edit"
                        disabled={is_read_only}
                        onClick={() => handleEditRace(race)}
                        sx={{ mr: 0.25, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete race">
                      <IconButton
                        size="small"
                        aria-label="delete"
                        disabled={is_read_only}
                        onClick={() => handleDeleteRace(race.race_id)}
                        sx={{ color: 'text.secondary', '&:hover': { color: 'error.main' } }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </ListItemSecondaryAction>
                </ListItem>
              </React.Fragment>
            ))}
          </List>
          {eventRaces.length === 0 && (
            <Box
              sx={{
                p: 3,
                textAlign: 'center',
                border: 1,
                borderColor: 'divider',
                borderRadius: 1,
                color: 'text.secondary',
                fontSize: '0.875rem'
              }}
            >
              No races yet. Add a race to start entering results.
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRacesDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* New Race Dialog */}
      <Dialog
        open={openNewRaceDialog}
        onClose={() => setOpenNewRaceDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add New Race</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Race Name"
                value={newRace.race_name}
                onChange={(e) => setNewRace({ ...newRace, race_name: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Race Type</InputLabel>
                <Select
                  value={newRace.race_type}
                  label="Race Type"
                  onChange={(e) => {
                    const type = raceTypes.find(t => t.value === e.target.value);
                    setNewRace({ 
                      ...newRace, 
                      race_type: e.target.value,
                      race_order: type ? type.order : 1
                    });
                  }}
                >
                  {raceTypes.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>Car Count <Tooltip title="This controls how many rows are shown for result entry in this race. It does NOT affect points calculation."><InfoOutlinedIcon sx={{ fontSize: 14, color: 'text.disabled', cursor: 'help' }} /></Tooltip></Box>}
                type="number"
                value={newRace.car_count}
                onChange={(e) => setNewRace({ ...newRace, car_count: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Notes"
                multiline
                rows={4}
                value={newRace.notes}
                onChange={(e) => setNewRace({ ...newRace, notes: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenNewRaceDialog(false)}>Cancel</Button>
          <Button onClick={handleAddRace} variant="contained" color="primary" disabled={is_read_only}>
            Add Race
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Race Dialog */}
      <Dialog
        open={openEditRaceDialog}
        onClose={() => setOpenEditRaceDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Race</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Race Name"
                value={newRace.race_name}
                onChange={(e) => setNewRace({ ...newRace, race_name: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Race Type</InputLabel>
                <Select
                  value={newRace.race_type}
                  label="Race Type"
                  onChange={(e) => {
                    const type = raceTypes.find(t => t.value === e.target.value);
                    setNewRace({ 
                      ...newRace, 
                      race_type: e.target.value,
                      race_order: type ? type.order : 1
                    });
                  }}
                >
                  {raceTypes.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Car Count"
                type="number"
                value={newRace.car_count}
                onChange={(e) => setNewRace({ ...newRace, car_count: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Notes"
                multiline
                rows={4}
                value={newRace.notes}
                onChange={(e) => setNewRace({ ...newRace, notes: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditRaceDialog(false)}>Cancel</Button>
          <Button onClick={handleUpdateRace} variant="contained" color="primary" disabled={is_read_only}>
            Update Race
          </Button>
        </DialogActions>
      </Dialog>

      {/* Results Dialog */}
      <Dialog
        open={openResultsDialog}
        onClose={() => setOpenResultsDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            height: '90vh',
            maxHeight: '90vh'
          }
        }}
      >
        <DialogTitle sx={{ pb: 0.5 }}>
          {selectedRace ? (
            <>Manage Results &mdash; {selectedRace.race_name}</>
          ) : 'Manage Results'}
        </DialogTitle>
        {selectedRace && (
          <Box sx={{ px: 3, pb: 1.5 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              {selectedEvent?.track_name && <>{selectedEvent.track_name} &middot; </>}
              {selectedEvent?.division_name && <>{selectedEvent.division_name} &middot; </>}
              {raceTypes.find((t) => t.value === selectedRace.race_type)?.label || selectedRace.race_type} &middot; {dayjs.utc(selectedRace.event_date).format('MMM D, YYYY')}
              {selectedRace.car_count > 0 && <> &middot; {selectedRace.car_count} cars entered</>}
            </Typography>
          </Box>
        )}
        <DialogContent>
          <Box sx={{ mb: 2, p: 2, border: 1, borderColor: 'divider', borderRadius: 1, backgroundColor: 'background.paper' }}>
            {is_read_only && (
              <Alert severity="warning" sx={{ mb: 1.5 }}>
                Read-only access: you can view results, but editing and importing are disabled.
              </Alert>
            )}
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 1.5 }}>
              <Typography variant="subtitle2" fontWeight={600}>
                Import from MyRacePass
              </Typography>
              {selectedEvent && (
                <Typography variant="caption" color="text.secondary">
                  &middot; {selectedEvent.division_name}
                </Typography>
              )}
            </Box>
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
              <TextField
                value={mrpResultsEventId}
                onChange={(e) => {
                  setMrpResultsEventId(e.target.value);
                  setMrpPreviewData(null);
                  setSelectedMrpDivision('');
                }}
                placeholder="Event ID or MyRacePass URL"
                size="small"
                sx={{
                  flex: 1,
                  '& .MuiOutlinedInput-root': { backgroundColor: 'background.paper' },
                  '& .MuiOutlinedInput-input': { py: '8px', px: '12px', fontSize: '0.9rem' }
                }}
              />
              <Button
                variant="outlined"
                size="small"
                onClick={handlePreviewMyRacePassDivisions}
                disabled={mrpPreviewLoading || !mrpResultsEventId.trim()}
                startIcon={mrpPreviewLoading ? <CircularProgress size={16} /> : null}
                sx={{ whiteSpace: 'nowrap', minHeight: 38 }}
              >
                {mrpPreviewLoading ? 'Loading...' : 'Preview'}
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={handleImportMyRacePassResults}
                disabled={is_read_only || mrpResultsLoading || !mrpResultsEventId.trim() || !selectedMrpDivision}
                startIcon={mrpResultsLoading ? <CircularProgress size={16} /> : null}
                sx={{ whiteSpace: 'nowrap', minHeight: 38 }}
              >
                {mrpResultsLoading ? 'Importing...' : 'Import Results'}
              </Button>
            </Box>
            {mrpPreviewData && mrpPreviewData.divisions.length > 0 && (
              <Box sx={{ mt: 1.5 }}>
                <FormControl size="small" fullWidth>
                  <InputLabel id="mrp-division-select-label">MyRacePass division</InputLabel>
                  <Select
                    labelId="mrp-division-select-label"
                    label="MyRacePass division"
                    value={selectedMrpDivision}
                    onChange={(e) => setSelectedMrpDivision(e.target.value)}
                  >
                    {mrpPreviewData.divisions.map((division) => {
                      const raceCount = division.races.length;
                      const isSuggested = division.mrp_division_name === mrpPreviewData.suggested_mrp_division_name;
                      return (
                        <MenuItem key={division.mrp_division_name} value={division.mrp_division_name}>
                          {division.mrp_division_name} ({raceCount} race{raceCount !== 1 ? 's' : ''})
                          {isSuggested ? ' — suggested' : ''}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {selectedEvent?.division_name && selectedMrpDivision && (
                    <FormHelperText>
                      Importing into local division: {selectedEvent.division_name}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            )}
            {mrpPreviewData && mrpPreviewData.divisions.length === 0 && (
              <Alert severity="warning" sx={{ mt: 1.5 }}>
                No divisions found in this MyRacePass event.
              </Alert>
            )}
          </Box>
          
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 80 }}>Position</TableCell>
                  <TableCell>Driver</TableCell>
                  <TableCell sx={{ width: 70 }}>Car #</TableCell>
                  <TableCell sx={{ width: 70 }}>Points</TableCell>
                  <TableCell sx={{ width: 120 }}>Status</TableCell>
                  <TableCell sx={{ minWidth: 180 }}>Manual Pts / Override</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {raceResults.map((result, index) => {
                  // Determine if this is a problematic MyRacePass import
                  const isImportedFromMRP = result.mrp_driver_name;
                  const hasMatchingIssues = isImportedFromMRP && (
                    !result.driver_matched || 
                    result.driver_match_type === 'error' ||
                    result.driver_match_type === 'fuzzy'
                  );
                  
                  return (
                  <TableRow
                    key={result.temp_id || result.result_id}
                    sx={{
                      backgroundColor: hasMatchingIssues
                        ? 'rgba(220, 38, 38, 0.04)'
                        : isImportedFromMRP && result.driver_matched
                        ? 'rgba(21, 128, 61, 0.04)'
                        : 'inherit',
                      '&:hover': {
                        backgroundColor: hasMatchingIssues
                          ? 'rgba(220, 38, 38, 0.08)'
                          : isImportedFromMRP && result.driver_matched
                          ? 'rgba(21, 128, 61, 0.08)'
                          : 'action.hover'
                      },
                      '& .MuiTableCell-root': { py: 1 }
                    }}
                  >
                    <TableCell>
                      {result.finish_position}
                    </TableCell>
                    <TableCell>
                      {/* MyRacePass import status indicator */}
                      {isImportedFromMRP && (
                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                          {hasMatchingIssues ? (
                            <Tooltip title={`MyRacePass import issue: ${result.notes || 'Match failed'}`}>
                              <ErrorOutlineIcon color="error" sx={{ fontSize: 16 }} />
                            </Tooltip>
                          ) : (
                            <Tooltip title={`MyRacePass import successful: ${result.driver_match_type}`}>
                              <CheckCircleOutlineIcon color="success" sx={{ fontSize: 16 }} />
                            </Tooltip>
                          )}
                          <Typography variant="caption" color="text.secondary">
                            MRP: {result.mrp_driver_name}
                          </Typography>
                        </Box>
                      )}
                      <Autocomplete
                        options={[
                          // Only show create option if there's actual input text
                          ...((driverSearchInputs[index] || '').trim() ? [{ isCreateOption: true, inputValue: driverSearchInputs[index] || '' }] : []),
                          ...(result.driver && !driverSearchResultsMap[index]?.some(d => d.driver_id === result.driver.driver_id) ? [result.driver] : []),
                          ...(driverSearchResultsMap[index] || []),
                          ...(result.driver_id && driverCache.current[result.driver_id] &&
                            !driverSearchResultsMap[index]?.some(d => d.driver_id === result.driver_id) &&
                            (!result.driver || driverCache.current[result.driver_id].driver_id !== result.driver.driver_id)
                            ? [driverCache.current[result.driver_id]] : [])
                        ].filter((option, idx, self) => 
                           option.isCreateOption || idx === self.findIndex(o => o.driver_id === option.driver_id)
                        )}
                        getOptionLabel={(option) => {
                          if (option.isCreateOption) {
                            return `Create new driver: "${option.inputValue}"`;
                          }
                          return `${option.car_number} - ${option.first_name} ${option.last_name}`;
                        }}
                        renderOption={(props, option) => {
                          const { key, ...rest } = props;
                          if (option.isCreateOption) {
                            return (
                              <li key={`create-${option.inputValue}`} {...rest}>
                                <AddIcon sx={{ mr: 1 }} />
                                Create new driver: "{option.inputValue}"
                              </li>
                            );
                          }
                          return <li key={option.driver_id || option.car_number || option.inputValue} {...rest}>{`${option.car_number} - ${option.first_name} ${option.last_name}`}</li>;
                        }}
                        value={result.driver || null}
                        isOptionEqualToValue={(option, value) => option.driver_id === value.driver_id}
                        onChange={(event, newValue) => {
                          console.log('Autocomplete onChange', newValue);
                          if (newValue?.isCreateOption) {
                            const inputText = (driverSearchInputs[index] || '').trim();
                            // Only proceed if there's actual input text
                            if (inputText) {
                              const names = inputText.split(' ');
                              setNewDriver(prev => ({
                                ...prev,
                                first_name: names[0] || '',
                                last_name: names.slice(1).join(' ') || ''
                              }));
                              setOpenNewDriverDialog(true);
                            }
                          } else {
                            handleUpdateResult(index, 'driver', newValue);
                          }
                        }}
                        disabled={is_read_only}
                        inputValue={driverSearchInputs[index] || ''}
                        onInputChange={(event, value) => {
                          setDriverSearchInputs(prev => ({ ...prev, [index]: value }));
                          fetchDriverSearchResults(value, index);
                        }}
                        loading={!!driverSearchLoadingMap[index]}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            onKeyDown={(event) => {
                              // Only handle Enter key if the autocomplete dropdown is open and an option is highlighted
                              // This prevents automatic selection when just tabbing through or pressing enter to move to next field
                              if (event.key === 'Tab') {
                                // Allow normal tab behavior - don't select anything
                                return;
                              }
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {driverSearchLoadingMap[index] ? (
                                    <CircularProgress color="inherit" size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        sx={{ minWidth: 300 }}
                        ListboxProps={{
                          style: {
                            maxHeight: '300px'
                          }
                        }}
                        clearOnBlur={false}
                        selectOnFocus={false}
                        autoHighlight={false}
                      />
                    </TableCell>
                    <TableCell>
                      {result.car_number}
                    </TableCell>
                    <TableCell>
                      {result.is_manual_points && result.manual_points_input !== '' ? parseFloat(result.manual_points_input) : (result.points_earned !== null ? result.points_earned : '-')}
                    </TableCell>
                    <TableCell>
                      <Select
                        size="small"
                        value={result.status}
                        onChange={(e) => handleUpdateResult(index, 'status', e.target.value)}
                        disabled={is_read_only}
                        sx={{ fontSize: '0.85rem', '& .MuiSelect-select': { py: '6px', px: '10px' } }}
                      >
                        {statusOptions.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TextField
                          type="number"
                          size="small"
                          value={result.manual_points_input}
                          onChange={(e) => handleUpdateResult(index, 'manual_points_input', e.target.value)}
                          disabled={is_read_only || !result.is_manual_points}
                          sx={{ width: '80px', '& .MuiOutlinedInput-input': { py: '6px', px: '10px', fontSize: '0.85rem' } }}
                          inputProps={{ 'aria-label': `manual points for row ${index + 1}` }}
                        />
                        <Switch 
                          checked={result.is_manual_points}
                          onChange={(e) => handleUpdateResult(index, 'is_manual_points', e.target.checked)}
                          disabled={is_read_only}
                          size="small"
                          inputProps={{ 'aria-label': `toggle manual points for row ${index + 1}` }}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenResultsDialog(false)}>Close</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveAllResults}
            disabled={is_read_only}
          >
            Save All Results
          </Button>
        </DialogActions>
      </Dialog>

      {/* New Driver Dialog */}
      <Dialog open={openNewDriverDialog} onClose={() => setOpenNewDriverDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Create New Driver</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="First Name"
                value={newDriver.first_name}
                onChange={(e) => setNewDriver({ ...newDriver, first_name: e.target.value })}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Last Name"
                value={newDriver.last_name}
                onChange={(e) => setNewDriver({ ...newDriver, last_name: e.target.value })}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Car Number"
                value={newDriver.car_number}
                onChange={(e) => setNewDriver({ ...newDriver, car_number: e.target.value })}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Hometown"
                value={newDriver.hometown}
                onChange={(e) => setNewDriver({ ...newDriver, hometown: e.target.value })}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>State</InputLabel>
                <Select
                  value={newDriver.state}
                  onChange={(e) => setNewDriver({ ...newDriver, state: e.target.value })}
                  label="State"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {US_STATES.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenNewDriverDialog(false)}>Cancel</Button>
          <Button
            onClick={handleCreateNewDriver}
            variant="contained"
            disabled={!(newDriver.first_name || '').trim() || !(newDriver.last_name || '').trim() || !(newDriver.car_number || '').trim()}
          >
            Create Driver
          </Button>
        </DialogActions>
      </Dialog>

      {/* Saving Dialog */}
      {openSavingDialog && savingStatus.status && (
        <Dialog
          open={openSavingDialog}
          aria-labelledby="saving-dialog-title"
          PaperProps={{
            sx: {
              minWidth: '300px',
              textAlign: 'center',
              p: 2
            }
          }}
        >
        <DialogTitle id="saving-dialog-title">
          {savingStatus.status === 'progress' ? 'Saving...' : 
           savingStatus.status === 'success' ? 'Success!' : 
           savingStatus.status === 'error' ? 'Error' :
           'Processing...'}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            gap: 2 
          }}>
            {savingStatus.status === 'progress' && (
              <CircularProgress size={40} />
            )}
            {savingStatus.status === 'success' && (
              <CheckCircleOutlineIcon color="success" sx={{ fontSize: 40 }} />
            )}
            {savingStatus.status === 'error' && (
              <ErrorOutlineIcon color="error" sx={{ fontSize: 40 }} />
            )}
            <Typography>
              {savingStatus.message}
            </Typography>
          </Box>
        </DialogContent>
        {savingStatus.status === 'error' && (
          <DialogActions>
            <Button onClick={() => setOpenSavingDialog(false)}>Close</Button>
          </DialogActions>
        )}
        </Dialog>
      )}



      {/* Division Mismatch Dialog */}
      <Dialog open={showDivisionMismatchDialog} onClose={() => setShowDivisionMismatchDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ErrorOutlineIcon color="warning" />
            Division Name Mismatch
          </Box>
        </DialogTitle>
        <DialogContent>
          {divisionMismatchData && (
            <Box>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Could not find a matching division in MyRacePass for "<strong>{divisionMismatchData.localDivision}</strong>".
              </Typography>
              
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                Available divisions in MyRacePass:
              </Typography>
              <Box component="ul" sx={{ ml: 2, mb: 2 }}>
                {divisionMismatchData.availableDivisions.map((divName, index) => (
                  <Typography key={index} component="li" variant="body2" sx={{ mb: 0.5 }}>
                    {divName}
                  </Typography>
                ))}
              </Box>
              
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {divisionMismatchData.suggestion}
              </Typography>
              
              <Box sx={{ p: 2, backgroundColor: 'info.light', borderRadius: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                  💡 Quick Solutions:
                </Typography>
                <Typography variant="body2" component="div">
                  1. <strong>Check division name:</strong> Verify your local division name matches one of the above
                  <br />
                  2. <strong>Use Preview:</strong> Click "Preview Divisions" before importing to see available divisions
                  <br />
                  3. <strong>Contact support:</strong> If this should match, we can add a mapping for future imports
                </Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDivisionMismatchDialog(false)}>
            Close
          </Button>
          <Button 
            variant="contained" 
            onClick={() => {
              setShowDivisionMismatchDialog(false);
              handlePreviewMyRacePassDivisions();
            }}
          >
            Preview Divisions
          </Button>
        </DialogActions>
      </Dialog>

      <ErrorAlert
        error={error}
        onClose={() => setError(null)}
      />

      <Snackbar
        open={alert.show}
        autoHideDuration={6000}
        onClose={() => setAlert(prev => ({ ...prev, show: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setAlert(prev => ({ ...prev, show: false }))}
          severity={alert.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default RaceEntry; 
